/**
 * 购物车
 */
(function () {
	var countryInfo = WS.ui.countryInfoMap[WS.site.country];
	var pointRatio = WS.ui.pointRatio;
	var originCartAmount = 0; // 原始购物车金额，未计算折扣
	var originCartTotalDiscount = 0; // 原始购物车折扣金额
	var originCartDiscountTagsHtml = ''; // 原始购物车折扣标签html
	var originCartNumber = 0; // 原始购物车数量
	var originCartDataReady = false; // cart-data 是否已成功返回；未 ready 前不展示动态活动文案，避免首屏短暂显示错误档位
	var originCartCampaignNumber = 0; // 动态活动文案使用的有效商品数量；排除规则在 Liquid 中统一计算
	var originCartItemList = []; // 原始购物车列表
	var originCartOnSellItemsDom = []; // 原始购物车在售商品dom
	var curShippingFreeText = '';
	var INCREASE_TYPE = 1;
	var MINUS_TYPE = 0;
	var CHANGE_TYPE = 2;
	var PRE_ORDER_CART_MAX_QUANTITY = 10;
	var cartList = [];
	var cartObj = {}; // 这里存的在售商品 {id: quantity}
	// 优惠券
	var storeCoupon = 'graecove_cart_coupon';
	var userCouponList = []; // 优惠券集合
	var userAvailableCouponList = []; // 用户可用优惠券
	var confirmUseCoupon = ''; // 选中使用的优惠券
	var confirmUseRedeemCode = ''; // 积分兑换的优惠券
	// 上报需要的checkout来源
	var checkoutReportFrom = '';
	var cartDrawerReturnFocusEl = null;
	var cartFocusAfterUpdate = null;
	function announceCart(message) {
		var status = document.getElementById('ws-cart-a11y-status');
		if (!status && WS.site.page === 'cart') {
			status = document.createElement('p');
			status.id = 'ws-cart-a11y-status';
			status.className = 'ws-cart-a11y-status';
			status.setAttribute('role', 'status');
			status.setAttribute('aria-live', 'polite');
			document.body.appendChild(status);
		}
		if (status) status.textContent = message || '';
	}
	function restoreCartFocusAfterUpdate() {
		if (!cartFocusAfterUpdate) return;
		var target = null;
		if (cartFocusAfterUpdate.variantId) {
			var row = Array.prototype.find.call(document.querySelectorAll('.cart-item_container-box'), function(item) { return item.getAttribute('data-variant-id') === cartFocusAfterUpdate.variantId; });
			target = row && row.querySelector(cartFocusAfterUpdate.selector);
		}
		if (!target) target = document.querySelector(cartFocusAfterUpdate.selector) || document.querySelector('#submit-btn') || document.querySelector('#cart-drawer.is-active .cart-header__close');
		if (target) target.focus();
		announceCart(cartFocusAfterUpdate.message);
		cartFocusAfterUpdate = null;
	}
	/** 订阅折扣码 */
	var SUBSCRIBE_DISCOUNT_CODE = 'WELCOME15';
	var SUBSCRIBE_DISCOUNT_PERCENT = 0.15;
	var SUBSCRIBE_DISCOUNT_OFF_SESSION_KEY = 'westyle_auto_apply_discount_off';
	/** 优惠券白名单：开启后购物车自动应用最优白名单券 */
	var USE_COUPON_WHITE_LIST = false;
	var COUPON_WHITE_LIST = [
		{
			code: 'Memorial20',
			discountPercent: 0.2
		}
	];
	var COUPON_WHITE_LIST_OFF_SESSION_KEY = 'westyle_auto_apply_coupon_white_list_off';
	var PICK_ANY_TWO_COMPLETE_SESSION_KEY = 'westyle_pick_any_two_completed';
	var subscribeDiscount = 0;
	var originCartSubtotal = '';
	var isShowSubscribeModule = false;

	/** 删除折扣后重新渲染底部前若小计弹层为展开，则渲染完成后恢复展开 */
	var restoreSubtotalPopAfterNextBottomRender = false;

	/** 订阅折扣条左右文案：窄宽度时缩小字号（cartFn.fitCartDiscountModuleText） */
	var fitCartDiscountModuleTextTimer = null;
	var cartBoughtTogetherHtmlCache = {};
	var cartBoughtTogetherRequestSeq = 0;

	function normalizeDiscountCode(code) {
		return String(code || '').trim().toLowerCase();
	}

	function getSubscribeDiscountRemovedByUser() {
		try {
			return window.sessionStorage && window.sessionStorage.getItem(SUBSCRIBE_DISCOUNT_OFF_SESSION_KEY) === '1';
		} catch (e) {
			return false;
		}
	}

	function setSubscribeDiscountRemovedByUser(removed) {
		try {
			if (!window.sessionStorage) return;
			if (removed) {
				window.sessionStorage.setItem(SUBSCRIBE_DISCOUNT_OFF_SESSION_KEY, '1');
			} else {
				window.sessionStorage.removeItem(SUBSCRIBE_DISCOUNT_OFF_SESSION_KEY);
			}
		} catch (e) { /* ignore */ }
	}

	function getPickAnyTwoCompletedInSession() {
		try {
			return window.sessionStorage && window.sessionStorage.getItem(PICK_ANY_TWO_COMPLETE_SESSION_KEY) === '1';
		} catch (e) {
			return false;
		}
	}

	function setPickAnyTwoCompletedInSession() {
		try {
			if (window.sessionStorage) {
				window.sessionStorage.setItem(PICK_ANY_TWO_COMPLETE_SESSION_KEY, '1');
			}
		} catch (e) { /* ignore */ }
	}

	function getCouponWhiteListRemovedKey(code) {
		var normalized = normalizeDiscountCode(code);
		return normalized ? COUPON_WHITE_LIST_OFF_SESSION_KEY + '_' + normalized : '';
	}

	function getCouponWhiteListRemovedByUser(code) {
		try {
			var key = getCouponWhiteListRemovedKey(code);
			return !!key && window.sessionStorage && window.sessionStorage.getItem(key) === '1';
		} catch (e) {
			return false;
		}
	}

	function setCouponWhiteListRemovedByUser(code, removed) {
		try {
			var key = getCouponWhiteListRemovedKey(code);
			if (!key || !window.sessionStorage) return;
			if (removed) {
				window.sessionStorage.setItem(key, '1');
			} else {
				window.sessionStorage.removeItem(key);
			}
		} catch (e) { /* ignore */ }
	}

	function setAutoDiscountsRemovedByUser(removed) {
		setSubscribeDiscountRemovedByUser(removed);
		if (!Array.isArray(COUPON_WHITE_LIST)) {
			return;
		}
		for (var i = 0; i < COUPON_WHITE_LIST.length; i++) {
			var coupon = COUPON_WHITE_LIST[i];
			if (coupon && coupon.code) {
				setCouponWhiteListRemovedByUser(coupon.code, removed);
			}
		}
	}

	function getCouponWhiteListItem(code) {
		if (!USE_COUPON_WHITE_LIST || !Array.isArray(COUPON_WHITE_LIST)) {
			return null;
		}
		var target = normalizeDiscountCode(code);
		if (!target) {
			return null;
		}
		for (var i = 0; i < COUPON_WHITE_LIST.length; i++) {
			var coupon = COUPON_WHITE_LIST[i];
			if (coupon && normalizeDiscountCode(coupon.code) === target) {
				return coupon;
			}
		}
		return null;
	}

	function isCouponWhiteListCode(code) {
		return !!getCouponWhiteListItem(code);
	}

	function isAutoDiscountCode(code) {
		return normalizeDiscountCode(code) === normalizeDiscountCode(SUBSCRIBE_DISCOUNT_CODE) || isCouponWhiteListCode(code);
	}

	function getWhiteListCouponDiscountAmount(cart, coupon) {
		if (!cart || !coupon) {
			return 0;
		}
		var originTotalPrice = Number(cart.original_total_price);
		var discountPercent = Number(coupon.discountPercent);
		if (isNaN(originTotalPrice) || isNaN(discountPercent) || originTotalPrice <= 0 || discountPercent <= 0) {
			return 0;
		}
		return originTotalPrice * discountPercent;
	}

	function getSubscribeDiscountAmountFromCart(cart) {
		if (!cart) {
			return 0;
		}
		var originTotalPrice = Number(cart.original_total_price);
		if (isNaN(originTotalPrice) || originTotalPrice <= 0 || !SUBSCRIBE_DISCOUNT_PERCENT) {
			return 0;
		}
		return originTotalPrice * SUBSCRIBE_DISCOUNT_PERCENT;
	}

	function getAutoWhiteListCouponFromCart(cart) {
		if (!USE_COUPON_WHITE_LIST || !Array.isArray(COUPON_WHITE_LIST) || !COUPON_WHITE_LIST.length) {
			return null;
		}
		if (!cart || !cart.items || !cart.items.length) {
			return null;
		}
		var currentTotalDiscount = Number(cart.total_discount || 0);
		if (isNaN(currentTotalDiscount)) {
			currentTotalDiscount = 0;
		}
		var bestCoupon = null;
		var bestDiscountAmount = 0;
		for (var i = 0; i < COUPON_WHITE_LIST.length; i++) {
			var coupon = COUPON_WHITE_LIST[i];
			if (!coupon || !coupon.code) {
				continue;
			}
			if (getCouponWhiteListRemovedByUser(coupon.code)) {
				continue;
			}
			if (cartJsonHasDiscountCode(cart, coupon.code)) {
				return null;
			}
			var discountAmount = getWhiteListCouponDiscountAmount(cart, coupon);
			if (discountAmount > currentTotalDiscount && discountAmount > bestDiscountAmount) {
				bestCoupon = coupon;
				bestDiscountAmount = discountAmount;
			}
		}
		return bestCoupon;
	}

	function getAutoDiscountCandidateFromCart(cart) {
		if (!cart || !cart.items || !cart.items.length) {
			return null;
		}
		var currentTotalDiscount = Number(cart.total_discount || 0);
		if (isNaN(currentTotalDiscount)) {
			currentTotalDiscount = 0;
		}
		var bestCandidate = null;

		function pickCandidate(code, discountAmount) {
			if (!code || discountAmount <= currentTotalDiscount) {
				return;
			}
			if (!bestCandidate || discountAmount > bestCandidate.discountAmount) {
				bestCandidate = {
					code: code,
					discountAmount: discountAmount
				};
			}
		}

		var whiteListCoupon = getAutoWhiteListCouponFromCart(cart);
		if (whiteListCoupon && whiteListCoupon.code) {
			pickCandidate(whiteListCoupon.code, getWhiteListCouponDiscountAmount(cart, whiteListCoupon));
		}

		if (
			SUBSCRIBE_DISCOUNT_CODE &&
			!getSubscribeDiscountRemovedByUser() &&
			!cartJsonHasDiscountCode(cart, SUBSCRIBE_DISCOUNT_CODE) &&
			WS.ui.subscribeModuleFn &&
			WS.ui.subscribeModuleFn.isSubscribed === true &&
			WS.ui.subscribeModuleFn.isFirstOrder === true
		) {
			pickCandidate(SUBSCRIBE_DISCOUNT_CODE, getSubscribeDiscountAmountFromCart(cart));
		}

		return bestCandidate;
	}

	function cartJsonHasDiscountCode(cart, codeNeedle) {
		if (!cart || !codeNeedle) return false;
		var target = normalizeDiscountCode(codeNeedle);
		var codes = cart.discount_codes || [];
		var i;
		for (i = 0; i < codes.length; i++) {
			var c = codes[i];
			if (c && normalizeDiscountCode(c.code) === target && c.applicable !== false) {
				return true;
			}
		}
		var apps = cart.cart_level_discount_applications || [];
		for (i = 0; i < apps.length; i++) {
			if (apps[i] && normalizeDiscountCode(apps[i].title) === target) {
				return true;
			}
		}
		return false;
	}

	function getCartIncreaseLimit(increaseBtn) {
		var $increaseBtn = $(increaseBtn);
		if ($increaseBtn.attr('data-available') === 'false') {
			return {
				hasLimit: true,
				maxQuantity: 0
			};
		}

		var eta = $increaseBtn.attr('data-eta');
		if (eta) {
			var etaMs = Date.parse(String(eta));
			if (!isNaN(etaMs) && Date.now() < etaMs) {
				return {
					hasLimit: true,
					maxQuantity: PRE_ORDER_CART_MAX_QUANTITY
				};
			}
		}

		var isLowStock = $increaseBtn.attr('data-low-stock-status') === 'true';
		if (!isLowStock) {
			return {
				hasLimit: false,
				maxQuantity: null
			};
		}

		var availableCount = Number.parseInt($increaseBtn.attr('data-available-count'), 10);
		return {
			hasLimit: true,
			maxQuantity: isNaN(availableCount) ? 0 : availableCount
		};
	}

	function canIncreaseCartItem(increaseBtn, currentQuantity) {
		var limit = getCartIncreaseLimit(increaseBtn);
		if (!limit.hasLimit) {
			return {
				canIncrease: true,
				maxQuantity: null
			};
		}

		return {
			canIncrease: currentQuantity < limit.maxQuantity,
			maxQuantity: limit.maxQuantity
		};
	}

	/**
	 * 从当前 cart 中去掉一个折扣码，得到 POST /cart/update.js 的 discount 字符串（多码逗号分隔；空字符串表示清空）
	 * @returns {string|null} 新 discount 参数；null 表示无法解析、不应发请求
	 */
	function buildRemainingDiscountPayload(cart, codeOrTitleToRemove) {
		var needle = normalizeDiscountCode(codeOrTitleToRemove);
		if (!needle) {
			return null;
		}
		var list = cart.discount_codes || [];
		if (!list.length) {
			return null;
		}
		var remaining = [];
		var i;
		var removed = false;
		for (i = 0; i < list.length; i++) {
			var dc = list[i];
			if (!dc || !dc.code) {
				continue;
			}
			if (normalizeDiscountCode(dc.code) === needle) {
				removed = true;
				continue;
			}
			remaining.push(dc.code);
		}
		if (!removed && list.length) {
			var apps = cart.cart_level_discount_applications || [];
			for (i = 0; i < apps.length; i++) {
				if (apps[i] && normalizeDiscountCode(apps[i].title) === needle) {
					if (list.length === 1 && list[0].code) {
						return '';
					}
					break;
				}
			}
		}
		if (!removed && list.length) {
			return null;
		}
		return remaining.join(',');
	}

	/** 从 Shopify /cart/update.js 错误体中取出面向用户的文案（含已使用、不满足条件等） */
	function getCartDiscountApplyErrorMessage(body) {
		if (!body || typeof body !== 'object') {
			return '';
		}
		var msg = body.message;
		if (msg && String(msg).trim()) {
			return String(msg).trim();
		}
		if (body.description && String(body.description).trim()) {
			return String(body.description).trim();
		}
		if (body.descriptionHtml && String(body.descriptionHtml).trim()) {
			var raw = String(body.descriptionHtml);
			try {
				var tmp = typeof document !== 'undefined' ? document.createElement('div') : null;
				if (tmp) {
					tmp.innerHTML = raw;
					var text = (tmp.textContent || tmp.innerText || '').trim();
					if (text) return text;
				}
			} catch (e) { /* ignore */ }
			return raw.replace(/<[^>]+>/g, ' ').replace(/\s+/g, ' ').trim();
		}
		var errs = body.errors;
		if (typeof errs === 'string' && errs.trim()) {
			return errs.trim();
		}
		if (errs && typeof errs === 'object') {
			var parts = [];
			Object.keys(errs).forEach(function (k) {
				var v = errs[k];
				if (Array.isArray(v)) {
					v.forEach(function (x) {
						if (x) parts.push(String(x));
					});
				} else if (v) {
					parts.push(String(v));
				}
			});
			if (parts.length) {
				return parts.join(' ');
			}
		}
		return '';
	}

	function cartDiscountApplyFailed(httpOk, httpStatus, body) {
		if (!httpOk) return true;
		if (body == null || typeof body !== 'object') return true;
		if (body.status != null && Number(body.status) === 422) return true;
		return false;
	}

	function cartDiscountCodeApplied(cart, code) {
		var codes = cart && cart.discount_codes;
		return Array.isArray(codes) && codes.some(function (discount) {
			return discount && normalizeDiscountCode(discount.code) === normalizeDiscountCode(code) && discount.applicable === true;
		});
	}

	function clearCartDiscountError() {
		var input = document.getElementById('ws-cart-discount-input');
		var error = document.getElementById('ws-cart-discount-error');
		if (input) {
			input.removeAttribute('aria-invalid');
			input.removeAttribute('aria-describedby');
		}
		if (error) { error.textContent = ''; error.hidden = true; }
	}

	function showCartDiscountError(message) {
		var text = String(message || 'This discount code could not be applied.');
		announceCart('');
		var input = document.getElementById('ws-cart-discount-input');
		var error = document.getElementById('ws-cart-discount-error');
		if (error) { error.textContent = text; error.hidden = false; }
		if (input) {
			input.setAttribute('aria-invalid', 'true');
			input.setAttribute('aria-describedby', 'ws-cart-discount-error');
			input.focus();
		}
		if (!error) showCartDiscountApplyToast(text);
	}

	function showCartDiscountApplyToast(message, fallback) {
		var text = (message && String(message).trim()) ? String(message).trim() : (fallback || '');
		if (!text) return;
		announceCart(text);
		if (WS.ui.toastShowHandle) {
			WS.ui.toastShowHandle(text);
		}
	}

	/** 从 GET /cart.js 取当前仍适用的折扣码（结账前 update 行项目时需一并提交，否则 Shopify 可能丢掉购物车级折扣） */
	function getFirstApplicableCartDiscountCode(cart) {
		if (!cart || !cart.discount_codes || !cart.discount_codes.length) {
			return '';
		}
		var i;
		for (i = 0; i < cart.discount_codes.length; i++) {
			var dc = cart.discount_codes[i];
			if (dc && dc.code && dc.applicable !== false) {
				return String(dc.code).trim();
			}
		}
		return '';
	}

	/** 任意已写入购物车的折扣码（含 applicable 为 false 时，结账 URL 仍可能重新校验通过） */
	function getAnyCartDiscountCode(cart) {
		if (!cart || !cart.discount_codes || !cart.discount_codes.length) {
			return '';
		}
		var i;
		for (i = 0; i < cart.discount_codes.length; i++) {
			var dc = cart.discount_codes[i];
			if (dc && dc.code) {
				return String(dc.code).trim();
			}
		}
		return '';
	}

	/**
	 * 跳转结账：优先使用 ?discount= 带码（Shopify 官方支持），避免仅依赖 POST /cart → 重定向时折扣未带入结账页
	 * @param {object|null} cartJson /cart/update.js 返回的 cart 对象
	 */
	function goToCheckoutWithDiscount(cartJson) {
		if (window.shipInsureCartGuard) {
			window.shipInsureCartGuard.validate().then(function (result) {
				if (!window.shipInsureCartGuard.hasOtherProduct(result.cart)) {
					WS.ui.loadingBtnHide($('#submit-btn, #cart-klarna'));
					WS.ui.toastShowHandle('Package Protection can only be purchased with another product.');
					return;
				}
				continueToCheckoutWithDiscount(result.cart);
			}).catch(function () {
				WS.ui.loadingBtnHide($('#submit-btn, #cart-klarna'));
				WS.ui.toastShowHandle(WS.ui.errorMsgMap.baseError);
			});
			return;
		}
		continueToCheckoutWithDiscount(cartJson);
	}

	function continueToCheckoutWithDiscount(cartJson) {
		var base = (typeof WS !== 'undefined' && WS.site && WS.site.baseUrl) ? String(WS.site.baseUrl).replace(/\/$/, '') : '';
		var code = getFirstApplicableCartDiscountCode(cartJson || {});
		if (!code) {
			code = getAnyCartDiscountCode(cartJson || {});
		}
		if (!code) {
			var autoDiscountCandidate = getAutoDiscountCandidateFromCart(cartJson || {});
			if (autoDiscountCandidate && autoDiscountCandidate.code) {
				code = autoDiscountCandidate.code;
			}
		}
		if (code) {
			window.location.href = base + '/checkout?discount=' + encodeURIComponent(code);
			return;
		}

		$('#submit-hidden-btn').click();
	}

	/**
	 * 使用 JSON POST /cart/update.js 更新行数量，并携带当前 discount 码，避免仅提交 updates 导致结账页丢失折扣
	 */
	function cartApplyUpdatesPreservingDiscount(updatesObj, onSuccess, onError) {
		if (typeof fetch === 'undefined') {
			if (onError) onError(new Error('fetch unavailable'));
			return;
		}
		var base = (typeof WS !== 'undefined' && WS.site && WS.site.baseUrl) ? WS.site.baseUrl : '';
		fetch(base + '/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
			.then(function (r) {
				return r.json();
			})
			.then(function (cart) {
				var payload = { updates: updatesObj };
				var code = getFirstApplicableCartDiscountCode(cart);
				if (code) {
					payload.discount = code;
				}
				return fetch(base + '/cart/update.js', {
					method: 'POST',
					credentials: 'same-origin',
					headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
					body: JSON.stringify(payload),
				});
			})
			.then(function (r) {
				return r.text().then(function (text) {
					var body = null;
					try {
						body = text ? JSON.parse(text) : null;
					} catch (parseErr) {
						body = null;
					}
					return { ok: r.ok, status: r.status, body: body };
				});
			})
			.then(function (res) {
				if (cartDiscountApplyFailed(res.ok, res.status, res.body)) {
					if (onError) onError(res.body || res);
					return;
				}
				if (onSuccess) onSuccess(res.body);
			})
			.catch(function (e) {
				if (onError) onError(e);
			});
	}

	/**
	 * 手动应用 Shopify 购物车折扣码（POST /cart/update.js）
	 * @param {string} code
	 * @param {function(boolean, object=)} onDone 第一个参数表示是否成功
	 */
	function applyCartDiscountCodeRequest(code, onDone) {
		if (typeof fetch === 'undefined') {
			onDone && onDone(false);
			return;
		}
		var trimmed = String(code || '').trim();
		if (!trimmed) {
			showCartDiscountError('Please enter a discount code.');
			onDone && onDone(false);
			return;
		}
		WS.ui.loadingPopShow && WS.ui.loadingPopShow();
		var base = (typeof WS !== 'undefined' && WS.site && WS.site.baseUrl) ? WS.site.baseUrl : '';
		fetch(base + '/cart/update.js', {
			method: 'POST',
			credentials: 'same-origin',
			headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
			body: JSON.stringify({ discount: trimmed }),
		})
			.then(function (r) {
				return r.text().then(function (text) {
					var body = null;
					try {
						body = text ? JSON.parse(text) : null;
					} catch (parseErr) {
						body = null;
					}
					return { ok: r.ok, status: r.status, body: body };
				});
			})
			.then(function (res) {
				WS.ui.loadingPopHide && WS.ui.loadingPopHide();
				if (cartDiscountApplyFailed(res.ok, res.status, res.body) || !cartDiscountCodeApplied(res.body, trimmed)) {
					console.warn('[westyle-cart] discount apply failed:', res.status);
					var msg = getCartDiscountApplyErrorMessage(res.body);
					if (!msg) {
						msg = res.ok === false
							? (WS.ui.errorMsgMap && WS.ui.errorMsgMap.baseError) || 'Something went wrong. Please try again.'
							: 'This discount code is invalid or not applicable to this cart.';
					}
					showCartDiscountError(msg);
					onDone && onDone(false);
					return;
				}
				clearCartDiscountError();
				onDone && onDone(true, res.body);
			})
			.catch(function (e) {
				console.warn('[westyle-cart] discount apply failed', e);
				WS.ui.loadingPopHide && WS.ui.loadingPopHide();
				showCartDiscountError(WS.ui.errorMsgMap.baseError);
				onDone && onDone(false);
			}).finally(function () {
				WS.ui.loadingPopHide && WS.ui.loadingPopHide();
			});
	}

	var cartDrawerOuter = `
		<section class="cart-drawer_container" id="cart-drawer">
		<div class="cart-drawer_container_overlay"></div>
		<div class="cart-drawer_container-wrapper" role="dialog" aria-modal="true" aria-labelledby="cart-drawer-title">
			<div class="cart-drawer_container-header">
				<button type="button" class="cart-header__close" aria-label="Close shopping cart">
					<img class="cart-header__close-icon" src="https://cdn.shopify.com/s/files/1/1994/9649/files/ws-icon-arrow-down-small.svg?v=1775185965" width="24" height="24" loading="lazy" alt="" />
	          		<img class="cart-header__close-pc-icon" src="https://cdn.shopify.com/s/files/1/1994/9649/files/ws-icon-close.svg?v=1773661484" width="24" height="24" loading="lazy" alt="" />
				</button>
				<div class="header-title-wrap">
					<span class="header-title" id="cart-drawer-title">${ WS.$t('bag.title', '', 1) } ${ WS.$t('bag.item_count', '', 1) } <span class="header-item-count" id="cart-drawer-header-count"></span></span>
				</div>
				<p id="ws-cart-a11y-status" class="ws-cart-a11y-status" role="status" aria-live="polite"></p>
			</div>
			<div class="cart-drawer_container_content-wrapper">
				<img id="cart-loading" class="loading-img" style="padding: 12px 15px;" src="https://cdn.shopify.com/s/files/1/0594/1162/8204/files/bodysize_loading.png?v=1647916707" />
				<div class="cart-drawer_container_content"></div>
			</div>
		</div>
	</section>
	`;
	// <img class="btn-wrapper-slide-down_icon cart-popup-detaiws-btn" loading="lazy" src="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/cart-discount-head-icon.png?v=1670396742" />
	// 购物车底部价格详情弹窗 html（折扣标签仍由 #discount-tags-wrapper 注入；类名沿用原有 btn-wrapper-pop-* / poplist-*）
	var cartBottomPriceDetailModel = `
		<div class="btn-wrapper-pop-abt-content">
			<div class="btn-wrapper-pop-list-abt btn-wrapper-pop-list-abt_sub-total">
				<div class="btn-wrapper-slide-down_icon-wrapper clickable">
					<img class="btn-wrapper-slide-down_icon cart-popup-detaiws-btn" src="https://cdn.shopify.com/s/files/1/1994/9649/files/ws-icon-arrow-down-small.svg?v=1775185965" width="24" height="24" loading="lazy" alt="" />
				</div>
				<div class="poplist-title"><%t('bag.subtotal') %></div>
				<div class="poplist-value poplist-value-price mr-r"><%= data.subTotal %></div>
			</div>
			<!--<div class="cart-discount-module__separator-line"></div>-->
			<div class="btn-wrapper-pop-list-abt btn-wrapper-pop-list-abt_discount">
				<div class="poplist-title"><%t('bag.discount') %></div>
				<div class="poplist-value poplist-value-discount mr-r">
					<div class="poplist-discount">-<%= data.totalDiscount %></div>
					<div class="discount-tags-wrapper" id="discount-tags-wrapper"></div>
					<div class="discount-input-wrapper">
						<label for="ws-cart-discount-input" class="ws-cart-discount-label">Discount code</label>
						<input type="text" class="ws-cart-discount-input" id="ws-cart-discount-input" name="discount" placeholder="Discount code" autocomplete="off" />
						<button type="button" class="ws-cart-discount-apply" id="ws-cart-discount-apply">Apply</button>
					</div>
					<p id="ws-cart-discount-error" class="ws-cart-discount-error" role="alert" hidden></p>
				</div>
			</div>
			<% if ( data.shippingStatus !== 0 ) { %>
			<div class="btn-wrapper-pop-list-abt btn-wrapper-pop-list-shipping">
				<div class="poplist-title"><%t('bag.shipping') %></div>
				<div class="poplist-value mr-r shipping-free"><%t('bag.shipping_free') %></div>
			</div>
			<% } %>
			<div class="btn-wrapper-pop-list-abt btn-wrapper-pop-tip-abt">
				<div class="poplist-title"><%t('bag.note_title') %></div>
				<div class="poplist-value mr-r"><%t('bag.note_text') %></div>
			</div>
		</div>
		<% if ( (data.isShowSubscribeModule && !data.isSubscribe) ) { %>
			<div class="cart-discount-module-wrapper" id="cart-discount-module-wrapper">
				<div class="cart-discount-module__content">
					<div class="cart-discount-module__content-left">
						<img class="cart-discount-module__icon" src="https://cdn.shopify.com/s/files/1/1994/9649/files/ws-icon-customers.svg?v=1776319230" width="20" height="20" loading="lazy" alt="" />
						<div class="cart-discount-module__label" id="cart-discount-module-label"></div>
					</div>
					<div class="cart-discount-module__discount" id="cart-discount-module-text-html"></div>
				</div>
				<!--<% if ( data.isSubscribe ) { %>
					<div class="cart-discount-module__button" id="cart-discount-module-button">Sign Up Now →</div>
				<% } %>-->
			</div>
		<% } %>
	`;

	var cartFn = {
		/** ensureAutoDiscountApplied 每次 GET/POST 后写入；onShowSubscribeModule 只读此快照 */
		_lastCartJsSnapshot: null,
		/** 记录打开 Free Gift Terms 的按钮，关闭弹窗时恢复焦点，避免隐藏弹窗内仍保留焦点。 */
		_freeGiftTermsOpener: null,

		/**
		 * 与 Liquid data-origin-total-price / data-total-discount 同源：GET /cart.js 的 original_total_price、total_discount（分）
		 */
		compareSubscribeDiscountFromCart: function (cart) {
			if (!cart || cart.original_total_price == null || cart.total_discount == null) {
				subscribeDiscount = 0;
				return false;
			}
			var originTotalPrice = Number(cart.original_total_price);
			var totalDiscount = Number(cart.total_discount);
			if (isNaN(originTotalPrice) || isNaN(totalDiscount)) {
				subscribeDiscount = 0;
				return false;
			}
			subscribeDiscount = originTotalPrice * SUBSCRIBE_DISCOUNT_PERCENT;
			return subscribeDiscount > totalDiscount;
		},

		shouldAutoApplySubscribeDiscountFromCart: function (cart) {
			if (!cart || !WS.ui.subscribeModuleFn) {
				return false;
			}
			if (WS.ui.subscribeModuleFn.isSubscribed != true) {
				return false;
			}
			if (WS.ui.subscribeModuleFn.isFirstOrder != true) {
				return false;
			}
			return this.compareSubscribeDiscountFromCart(cart);
		},

		/**
		 * 每次先 GET /cart.js 写入 _lastCartJsSnapshot；若存在更优自动折扣候选则 POST 最优折扣码
		 * @param {function} done 无论成功与否都会调用
		 */
		ensureAutoDiscountApplied: function (done) {
			var self = this;
			if (typeof fetch === 'undefined') {
				done && done();
				return;
			}

			var base = (typeof WS !== 'undefined' && WS.site && WS.site.baseUrl) ? WS.site.baseUrl : '';
			Promise.resolve(window.shipInsureCartGuard ? window.shipInsureCartGuard.validate() : null)
				.then(function () { return fetch(base + '/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } }); })
				.then(function (r) {
					return r.json();
				})
				.then(function (cart) {
					self._lastCartJsSnapshot = cart;
					if (!cart.items || !cart.items.length) {
						done && done();
						return;
					}

					var autoDiscountCandidate = getAutoDiscountCandidateFromCart(cart);
					var autoDiscountCode = autoDiscountCandidate && autoDiscountCandidate.code ? autoDiscountCandidate.code : '';

					if (!autoDiscountCode) {
						done && done();
						return;
					}

					return fetch(base + '/cart/update.js', {
						method: 'POST',
						credentials: 'same-origin',
						headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
						body: JSON.stringify({ discount: autoDiscountCode }),
					})
						.then(function (r) {
							return r.text().then(function (text) {
								var body = null;
								try {
									body = text ? JSON.parse(text) : null;
								} catch (parseErr) {
									body = null;
								}
								return { ok: r.ok, status: r.status, body: body };
							});
						})
						.then(function (res) {
							if (cartDiscountApplyFailed(res.ok, res.status, res.body)) {
								var msg = getCartDiscountApplyErrorMessage(res.body);
								if (!msg && res.ok === false) {
									msg = res.status === 422 ? 'This discount code could not be applied.' : '';
								}
								console.warn('[westyle-cart] auto discount:', msg || res.body || res.status);
							} else if (res.body && typeof res.body === 'object' && res.body.items) {
								self._lastCartJsSnapshot = res.body;
							}
							done && done();
						})
						.catch(function (e) {
							console.warn('[westyle-cart] auto discount request failed', e);
							done && done();
						});
				})
				.catch(function () {
					done && done();
				});
		},

		/**
		 * @param {object} cart GET /cart.js 返回对象
		 */
		onCompareSubscribeDiscount: function (cart) {
			if (!cart || typeof cart !== 'object') {
				subscribeDiscount = 0;
				return false;
			}
			var ok = this.compareSubscribeDiscountFromCart(cart);
			var $wsCartContent = $('#ws-cart-content');
			if ($wsCartContent.length) {
				$wsCartContent.attr('data-subscribe-discount', subscribeDiscount);
			}
			return ok;
		},

		/**
		 * 当前购物车快照是否已有生效的折扣（含自动应用的 code、cart_level 脚本折扣等）
		 */
		cartSnapshotHasApplicableDiscounts: function () {
			var cart = this._lastCartJsSnapshot;			
			if (!cart) return false;
			var codes = cart.discount_codes || [];
			var i;
			for (i = 0; i < codes.length; i++) {
				var dc = codes[i];
				if (dc && dc.code && String(dc.code).trim() && dc.applicable !== false) {
					return true;
				}
			}
			var apps = cart.cart_level_discount_applications || [];
			for (i = 0; i < apps.length; i++) {
				if (apps[i]) return true;
			}
			var items = cart.items || [];
			for (i = 0; i < items.length; i++) {
				var item = items[i];
				if (item && item.discounts && item.discounts.length > 0) {
					return true;
				}
			}
			return false;
		},

		/**
		 * 是否展示订阅模块（仅根据 ensureAutoDiscountApplied 写入的 _lastCartJsSnapshot）
		 */
		onShowSubscribeModule: function () {
			var cart = this._lastCartJsSnapshot;
			if (!cart) {
				isShowSubscribeModule = false;
				return;
			}
			if ((!WS.ui.subscribeModuleFn.isSubscribed || WS.ui.subscribeModuleFn.isFirstOrder) && this.onCompareSubscribeDiscount(cart)) {
				isShowSubscribeModule = true;
			} else {
				isShowSubscribeModule = false;
			}
		},

		/**
		 * 是否自动应用订阅折扣
		 * @param {object} [cart] 若有 original_total_price 则与 /cart.js 一致计算；否则依赖 onShowSubscribeModule 已跑完后的 isShowSubscribeModule
		 */
		isAutoApplySubscribeDiscount: function (cartOpt) {
			if (cartOpt && typeof cartOpt === 'object' && cartOpt.original_total_price != null) {
				return this.shouldAutoApplySubscribeDiscountFromCart(cartOpt);
			}
			if (WS.ui.subscribeModuleFn.isSubscribed === true && isShowSubscribeModule) {
				return true;
			}
			return false;
		},
		/**
		 * 通过westyle-cart-data.liquid获取最新的购物车商品状态，主要获取库存和是否售罄
		 */
		handleSubmit: function () {
			WS.ajax({
				url: WS.ui.routes.getCarJSONUrl,
				dataType: "html",
				success: function (res) {
					
					var responseHTML = JSON.parse(res || 'null')["westyle-cart-data"] || "";
					var $data = $(`<div>${responseHTML}</div>`);
					var cartItemsDOM = $data.find(".cart-item") || [];
					cartList = [];
					$.each(cartItemsDOM, function (index, item) {
						var json = JSON.parse($(item).find(".cart-json").text() || 'null') || {};
						var inventory_quantity =
							$(item).data("inventory-quantity");
						var available = $(item).data("available");
						json.inventory_quantity = inventory_quantity; // 库存量
						json.isSoldout = !available; // 是否售罄
						cartList.push(json);
					});
					cartFn.checkCartAvailable(cartList);
				},
				error: function (e) {
					console.log(e, 'error');
					WS.ui.toastShowHandle(WS.ui.errorMsgMap.baseError);
				},
			});
		},
		/**
		 * 售罄片段
		 * @returns
		 */
		renderSoldoutSlot: function () {
			var getSoldoutList = $("#sold-out-items").find(".cart-item_container");
			var len = getSoldoutList.length;
			var cartItems = "";
			var obj = {};
			if (len > 0) {
				for (var i = 0; i < len; i++) {
					var itemData =
						JSON.parse($(getSoldoutList[i]).find('.js-product-json').text() || 'null') || {};
					obj[itemData.id] = 0;
					// 添加货币code
					itemData.currencyCode = countryInfo.symbolCode;
					cartItems += cartFn.renderCartItem(itemData);
				}
			}
			obj = JSON.stringify(obj) || {};
			var slot = `
				<div class="cart-slot_wrapper">
					<p class="cart-slot_tip">${ WS.$t('bag.delete_subtext', '', 1) }</p>
					<div class="cart-solt_cart-items">${cartItems}</div>
					<div class="cart-slot_btn" id="confirm-delete-all-soldout" data-soldout=${obj}>${ WS.$t('bag.delete_btn', '', 1) }</div>
				</div>
			`;
			return slot;
		},
		/**
		 * 检查购物车商品库存数量和是否售罄
		 */
		checkCartAvailable: async function (arr) {
			var onSellItems = $("#on-sell-items").find(".cart-item_container");
			var soldoutItems = $("#sold-out-items").find(".cart-item_container");
			var onSellItemsLen = onSellItems.length;
			var soldoutLen = soldoutItems.length;
			var cartItems = "";
			var shouldHandleDelete = false;
			// 处理在售商品
			if (onSellItemsLen > 0) {
				for (var i = 0; i < onSellItemsLen; i++) {
					var onSellItemData =
						JSON.parse($(onSellItems[i]).find('.js-product-json').text() || 'null') || {};
					var onSellItemQuantity = onSellItemData.quantity || 0;
					var onSellItemCartId = onSellItemData.id;
					// cartJSON 对比的对象
					var onSellTarget = arr.find((item) => item.id + '' === onSellItemCartId);
					cartObj[onSellItemCartId] = onSellItemQuantity;
					// 对比cartJson数据
					if (onSellTarget) {
						// 获取库存数
						var max_quantity =
							Number.parseInt(onSellTarget.inventory_quantity) || 9999;
						// 判断是否售罄
						var isSoldout = onSellTarget.isSoldout || false;
						// 如果库存数小于当前选购数量，将选购数量设置为库存数，并cartItems添加上dom节点，设置shouldHandleDelete为true，需要弹窗
						if (max_quantity > 0 && max_quantity < onSellItemQuantity) {
							onSellItemData.max_quantity = max_quantity;
							cartObj[onSellItemCartId] = max_quantity;
							// 添加货币code
							onSellItemData.currencyCode = countryInfo.symbolCode;
							cartItems += cartFn.renderCartItem(onSellItemData);
							shouldHandleDelete = true;
						}
						// 如果刚好售罄，将isSoldout设置为true，数量设置为0，同时cartItems添加上dom节点
						if (isSoldout) {
							onSellItemData.isSoldout = isSoldout;
							cartObj[onSellItemCartId] = 0;
							// 添加货币code
							onSellItemData.currencyCode = countryInfo.symbolCode;
							cartItems += cartFn.renderCartItem(onSellItemData);
							shouldHandleDelete = true;
						}
					}
				}
			}
			// 处理当前售罄商品
			if (soldoutLen > 0) {
				for (var i = 0; i < soldoutLen; i++) {
				  var soldoutItemData =
					JSON.parse($(soldoutItems[i]).find('.js-product-json').text() || 'null') || {};
				  var soldoutItemCartId = soldoutItemData.id;
				  cartObj[soldoutItemCartId] = 0;
				}
			  }
			// 需要弹窗
			if (shouldHandleDelete) {
				var obj = JSON.stringify(cartObj) || {};
				var slot = `
					<div class="cart-slot_wrapper" id="cart-slot">
						<p class="cart-slot_tip">${ WS.$t('bag.delete_subtext2', '', 1) }</p>
						<div class="cart-solt_cart-items">${cartItems}</div>
						<div class="cart-slot_btn" id="check-submit" data-handle-items=${obj}>${ WS.$t('bag.delete_btn2', '', 1) }</div>
					</div>
				`;
				WS.ui.renderBottomDrawer({
					title: WS.$t('bag.sold_out_title', '', 1),
					slot,
				}, 'checkout');
			} else {
				cartFn.updateCart(cartObj);
			}
		},
		/**
     * 更新购物车商品数量
     * @param {} obj 	
     * updates: {
          794864053: 0,
          794864233: 0
        }
     */
		updateCart: function (obj) {
				cartApplyUpdatesPreservingDiscount(obj, function (cartJson) {
					goToCheckoutWithDiscount(cartJson);
				}, function () {
					WS.ui.toastShowHandle(WS.ui.errorMsgMap.baseError);
				});
			},
		/**
		 * 获取购物车data数据
		 * handleType: 1为加购
		 */
		getCartDataInfo: function (type, handleType, callback, firstLoad) {
			return new Promise(function(resolve, reject) {
				WS.ajax({
					url: WS.ui.routes.getCarJSONUrl,
					dataType: "html",
					success: async function(res) {
						var responseHTML = JSON.parse(res || 'null')["westyle-cart-data"] || "";
						var $data = $(`<div>${responseHTML}</div>`);
						var cartDOM = $data.find(".cart-data") || 'null';
						var acount = $(cartDOM).find(".acount").text() || 0;
						var campaignAcount = Number($(cartDOM).find(".campaign-acount").text()) || 0;
						var freeGiftEligibleSubtotalCents = Number($(cartDOM).find(".free-gift-eligible-subtotal-cents").text()) || 0;
						var freeGiftThresholdUsdCents = Number($(cartDOM).find(".free-gift-unlock-threshold-usd-cents").text()) || Number($(cartDOM).find(".free-gift-unlock-threshold-cents").text()) || 40000;
						var freeGiftThresholdCents = cartFn.getFreeGiftPresentmentThresholdCents(freeGiftThresholdUsdCents);
						var originalTotal = $(cartDOM).find(".original-total-price").text() || '';
						var itemsSubtotal = $(cartDOM).find(".items-subtotal-price").text() || '';
						var total = $(cartDOM).find(".total").text() || 0;
						var totalDiscount = $(cartDOM).find(".total-discount").text() || 0;
						var discountTagsHtml = $(cartDOM).find(".discount-tags-html").html() || '';
						var cartItemsJSON = $(cartDOM).find('.cart-items') ? $(cartDOM).find('.cart-items').text() : '[]';
						var cartItems = [];
						try {
							cartItems = JSON.parse(cartItemsJSON) || [];
						} catch (e) {
							cartItems = [];
						}
						originCartOnSellItemsDom = $(cartDOM).find('.on-sell-cart-items .cart-item_container-box') || [];
						originCartSubtotal = originalTotal || itemsSubtotal || total;
						originCartAmount = total;
						originCartTotalDiscount = totalDiscount;
						originCartDiscountTagsHtml = discountTagsHtml;
						originCartNumber = Number(acount);
						originCartItemList = cartItems;
						// 动态活动文案的排除规则只在 cart-data Liquid 中维护。
						// JS 只消费 campaign-acount，避免 vendor / product type 规则在两端重复实现后出现不一致。
						originCartCampaignNumber = campaignAcount;
						originCartDataReady = true;
						$('#ws-cart-bag').attr('value', total);
						// cart-data 请求成功后再派发事件：
						// - count 是真实购物车件数，继续给头部数量、购物车标题等通用逻辑使用；
						// - campaignCount 是活动文案档位件数，PDP/加购弹窗会读取这份排除后的数量；
						// - 放在所有数量更新之后派发，监听方拿到的一定是最新值。
						try {
							var cartCountEvent;
							var cartCountDetail = {
								count: originCartNumber,
								campaignCount: originCartCampaignNumber,
								freeGiftEligibleSubtotalCents: freeGiftEligibleSubtotalCents,
								freeGiftThresholdUsdCents: freeGiftThresholdUsdCents,
								freeGiftThresholdCents: freeGiftThresholdCents
							};
							if (typeof window.CustomEvent === 'function') {
								cartCountEvent = new CustomEvent('ws:cart-count-updated', { detail: cartCountDetail });
							} else {
								cartCountEvent = document.createEvent('CustomEvent');
								cartCountEvent.initCustomEvent('ws:cart-count-updated', false, false, cartCountDetail);
							}
							window.dispatchEvent(cartCountEvent);
						} catch (e) {}
						// 更新购物车弹窗头部数量
						var $headerCount = $('#cart-drawer-header-count');
						if ($headerCount.length) {
							var countText = Number(acount) === 1 ? ' (1 item)' : ' (' + acount + ' items)';
							$headerCount.text(countText);
						}
						// 显示修改head中购物车数量
						if (acount < 1) {
							$(".ws-header-cart-count").hide();
						} else if (acount >= 1 && acount < 100) {
							$(".ws-header-cart-count").text(acount);
							$(".ws-header-cart-count").show();
						} else {
							$(".ws-header-cart-count").text("99+");
							$(".ws-header-cart-count").show();
						}
						// 调用底部checkout区域abt方法
						cartFn.cartBottomCheckoutModelHanlde(firstLoad);
						cartFn.renderCartBoughtTogether();

						callback && typeof callback === "function" && callback(total);
						resolve();
					},
					error: function() {
						originCartDataReady = false;
						restoreSubtotalPopAfterNextBottomRender = false;
						reject();
					}
				});
			});
		},
		// 隐藏购物车 Bought Together 模块时要同步清空商品列表。
		// 原因：购物车数量从 1 件变成多件/空车时，旧推荐卡片不能残留在 DOM 里。
		hideCartBoughtTogether: function ($module) {
			$module = $module && $module.length ? $module : $('#ws-cart-collection');
			if (!$module.length) return;
			$module.hide().removeClass('is-active').removeAttr('data-source-key');
			$module.find('.ws-featured-collection-product-list').empty();
		},
		// Shopify `?sections=` 在不同调用链里可能返回 JSON 字符串，也可能已经被解析成对象。
		// 购物车 Bought Together 只关心目标 section 的 HTML，这里统一做容错解析，失败时返回空字符串。
		extractCartSectionHtml: function (res, sectionKey) {
			if (!res) return '';
			if (typeof res === 'object') {
				return res[sectionKey] || '';
			}
			try {
				return (JSON.parse(res || 'null') || {})[sectionKey] || '';
			} catch (e) {
				return '';
			}
		},
		// Free Gift 金额展示和门槛换算都使用当前展示币种。
		getFreeGiftCurrencyCode: function () {
			return (
				(typeof Shopify !== 'undefined' && Shopify.currency && Shopify.currency.active) ||
				(document.documentElement && document.documentElement.getAttribute('currency')) ||
				(WS.site && WS.site.currency) ||
				'USD'
			).toUpperCase();
		},
		// Free Gift 门槛按 400 USD 固定；非 USD 不能把启动时兜底的 1.0 当作真实汇率。
		getFreeGiftCurrencyRate: function () {
			var currency = cartFn.getFreeGiftCurrencyCode();
			var shopifyRate = typeof Shopify !== 'undefined' && Shopify.currency ? Number(Shopify.currency.rate) : 0;
			var siteRate = Number(WS.site && WS.site.rate);
			var converted = 0;

			if (currency === 'USD') return 1;
			if (shopifyRate > 0 && shopifyRate !== 1) return shopifyRate;

			if (typeof Currency !== 'undefined') {
				if (typeof Currency.convert === 'function') {
					converted = Number(Currency.convert(100, 'USD', currency));
					if (converted > 0 && converted !== 100) return converted / 100;
				} else if (Currency.rates && Currency.rates.USD && Currency.rates[currency]) {
					converted = Number(Currency.rates.USD) / Number(Currency.rates[currency]);
					if (converted > 0 && converted !== 1) return converted;
				}
			}

			if (siteRate > 0 && siteRate !== 1) return siteRate;
			return 1;
		},
		getFreeGiftPresentmentThresholdCents: function (usdCents) {
			var thresholdUsdCents = Number(usdCents) || 40000;
			return Math.round(thresholdUsdCents * cartFn.getFreeGiftCurrencyRate());
		},
		formatFreeGiftUnlockAmount: function (cents) {
			var amount = Math.max(0, Number(cents) || 0) / 100;
			var amountText = amount.toFixed(2);
			var symbol = (WS.site && WS.site.symbol) || '$';
			var formattedAmount = WS.i18n && WS.i18n.fmtAmount ? WS.i18n.fmtAmount(amountText) : amountText;
			return symbol + formattedAmount + ' ' + cartFn.getFreeGiftCurrencyCode();
		},
		getFreeGiftAddMoreUrl: function () {
			var root = (WS.site && WS.site.dir) || '';
			return root + '/collections/july-4th-sale';
		},
		syncFreeGiftModuleCurrencyState: function ($module) {
			var subtotalCents = Number($module.attr('data-free-gift-subtotal-cents')) || 0;
			var thresholdUsdCents = Number($module.attr('data-free-gift-threshold-usd-cents')) || 40000;
			var thresholdCents = cartFn.getFreeGiftPresentmentThresholdCents(thresholdUsdCents);
			var gapCents = thresholdCents - subtotalCents;
			var isUnlocked = gapCents <= 0;
			var gapText = cartFn.formatFreeGiftUnlockAmount(gapCents);
			var lockedMessage = 'Add ' + gapText + ' more to unlock.';
			var addMoreUrl = cartFn.getFreeGiftAddMoreUrl();
			var hasGiftInCart = $module.attr('data-has-free-gift-in-cart') === 'true';

			$module.toggleClass('ws-cart-free-gift--unlocked', isUnlocked);
			$module.find('[data-free-gift-copy]').html(isUnlocked ? "<strong>You've unlocked 1 free selected gift.</strong>" : 'Add <strong>' + gapText + '</strong> more to unlock');
			$module.find('.ws-cart-free-gift__add-more').attr('href', addMoreUrl).prop('hidden', isUnlocked);
			$module.find('.ws-cart-free-gift__list').prop('hidden', hasGiftInCart && !isUnlocked);
			$module.find('[data-cart-free-gift-footer], .ws-cart-free-gift__product-add').each(function () {
				var $target = $(this);
				$target.attr('data-locked', isUnlocked ? 'false' : 'true');
				if (isUnlocked) {
					$target.removeAttr('data-locked-message');
				} else {
					$target.attr('data-locked-message', lockedMessage);
				}
			});
		},
		syncFreeGiftPopupCurrencyState: function ($popup) {
			var subtotalCents = Number($popup.attr('data-free-gift-subtotal-cents')) || 0;
			var thresholdUsdCents = Number($popup.attr('data-free-gift-threshold-usd-cents')) || 40000;
			var thresholdCents = cartFn.getFreeGiftPresentmentThresholdCents(thresholdUsdCents);
			var gapCents = thresholdCents - subtotalCents;
			var isUnlocked = gapCents <= 0;
			var gapText = cartFn.formatFreeGiftUnlockAmount(gapCents);
			var lockedMessage = 'Add ' + gapText + ' more to unlock.';
			var addMoreUrl = cartFn.getFreeGiftAddMoreUrl();
			var selectedVariantId = String($popup.attr('data-selected-variant-id') || '');

			$popup.attr('data-unlocked', isUnlocked ? 'true' : 'false');
			$popup.attr('data-locked-message', lockedMessage);
			$popup.find('[data-free-gift-popup-status]')
				.toggleClass('ws-cart-free-gift-popup__status--unlocked', isUnlocked)
				.html(isUnlocked ? "<span>You've unlocked 1 free gift.</span>" : '<span>Add <strong>' + gapText + '</strong> more to unlock</span><a href="' + addMoreUrl + '">ADD MORE</a>');
			$popup.find('.ws-cart-free-gift-popup__choose').each(function () {
				var $btn = $(this);
				var isSelected = selectedVariantId && String($btn.attr('data-variant-id')) === selectedVariantId;
				if (isSelected) {
					$btn.addClass('is-selected').removeClass('is-disabled').prop('disabled', true).attr('data-locked', 'false').text('Selected ✓');
				} else if (isUnlocked) {
					$btn.removeClass('is-selected is-disabled').prop('disabled', false).attr('data-locked', 'false').text('Change to this');
				} else {
					$btn.removeClass('is-selected').addClass('is-disabled').prop('disabled', true).attr('data-locked', 'true').text('Choose Free Gift');
				}
			});
		},
		syncFreeGiftItemTipsCurrencyState: function ($item, allowTip) {
			allowTip = allowTip !== false;
			var subtotalCents = Number($item.attr('data-free-gift-subtotal-cents')) || 0;
			var thresholdUsdCents = Number($item.attr('data-free-gift-threshold-usd-cents')) || 40000;
			var gapCents = cartFn.getFreeGiftPresentmentThresholdCents(thresholdUsdCents) - subtotalCents;
			var shouldShow = allowTip
				&& $item.attr('data-free-gift-product') === 'true'
				&& $item.attr('data-free-gift-discounted') !== 'true'
				&& $item.attr('data-has-discounted-free-gift-in-cart') !== 'true'
				&& gapCents > 0;
			var $tip = $item.find('.cart-free-gift-unlock-tip').first();
			if (!$tip.length) return false;
			$tip.prop('hidden', !shouldShow);
			if (!shouldShow) return false;
			$tip.find('strong').text(cartFn.formatFreeGiftUnlockAmount(gapCents));
			$tip.find('a').attr('href', cartFn.getFreeGiftAddMoreUrl());
			return true;
		},
		syncFreeGiftCurrencyState: function ($scope) {
			var hasScope = $scope !== undefined && $scope !== null;
			if (hasScope && !$scope.length) return;
			var $root = hasScope ? $scope : $(document);
			var $modules = $root.find('.ws-cart-free-gift');
			var $popups = $root.find('.ws-cart-free-gift-popup');
			var $items = $root.find('.cart-item_container-box[data-free-gift-product="true"]');
			if ($root.is('.ws-cart-free-gift')) $modules = $modules.add($root);
			if ($root.is('.ws-cart-free-gift-popup')) $popups = $popups.add($root);
			if ($root.is('.cart-item_container-box[data-free-gift-product="true"]')) $items = $items.add($root);
			$modules.each(function () {
				cartFn.syncFreeGiftModuleCurrencyState($(this));
			});
			$popups.each(function () {
				cartFn.syncFreeGiftPopupCurrencyState($(this));
			});
			var hasVisibleFreeGiftItemTip = false;
			$items.each(function () {
				if (cartFn.syncFreeGiftItemTipsCurrencyState($(this), !hasVisibleFreeGiftItemTip)) {
					hasVisibleFreeGiftItemTip = true;
				}
			});
			cartFn.syncCartDrawerBottomInset($root);
		},
		syncPickAnyTwoGuidance: function ($scope) {
			var hasScope = $scope !== undefined && $scope !== null;
			if (hasScope && !$scope.length) return;
			var $root = hasScope ? $scope : $(document);
			var $states = $root.find('.ws-pick-any-two-state');
			var $prompts = $root.find('[data-pick-any-two-guidance]');
			if ($root.is('.ws-pick-any-two-state')) $states = $states.add($root);
			if ($root.is('[data-pick-any-two-guidance]')) $prompts = $prompts.add($root);

			var completedByCart = false;
			$states.each(function () {
				if ($(this).attr('data-pick-any-two-complete') === 'true') {
					completedByCart = true;
					return false;
				}
			});
			if (completedByCart) {
				setPickAnyTwoCompletedInSession();
			}

			$prompts.prop('hidden', true).attr('aria-hidden', 'true').removeClass('is-active');
			if (!completedByCart && !getPickAnyTwoCompletedInSession() && $prompts.length) {
				$prompts.first().prop('hidden', false).attr('aria-hidden', 'false').addClass('is-active');
			}
		},
		// 根据触发入口就近查找弹窗，FAB 和购物车抽屉同时存在时优先打开当前区域的 popup。
		findFreeGiftPopupForTrigger: function ($trigger) {
			var $popup = $();
			if ($trigger && $trigger.length) {
				var $scope = $trigger.closest('.ws-product__basic-info-wrapper, .section-westyle-free-gift-fab, .ws-complete-the-look-wrapper, #cartform, .cart-drawer_container_content, #cart-template');
				if ($scope.length) {
					$popup = $scope.find('.ws-cart-free-gift-popup').first();
				}
			}
			return $popup.length ? $popup : $('.ws-cart-free-gift-popup').first();
		},
		// 用最新购物车 section 里的弹窗内容同步外部入口，避免 PDP / FAB 首屏渲染的数据变旧。
		syncFreeGiftPopupFromHtml: function (responseHTML, $scope) {
			var $sections = $scope && $scope.length ? $scope : $('.ws-product__basic-info-wrapper, .section-westyle-free-gift-fab, .ws-complete-the-look-wrapper');
			if (!$sections.length || !responseHTML) return false;
			var $newPopup = $('<div>' + responseHTML + '</div>').find('.ws-cart-free-gift-popup').first();
			if (!$newPopup.length) return false;
			$sections.each(function () {
				var $section = $(this);
				var $oldPopup = $section.find('.ws-cart-free-gift-popup').first();
				var wasActive = $oldPopup.hasClass('is-active');
				var $clone = $newPopup.clone();
				if (wasActive) {
					$clone.addClass('is-active').attr('aria-hidden', 'false');
				}
				if ($oldPopup.length) {
					$oldPopup.replaceWith($clone);
				} else {
					$section.append($clone);
				}
			});
			// 如果弹窗已经被挂到 body 下打开，也同步替换这份浮层，确保 Selected / line key 是最新状态。
			var $activeFloatingPopup = $('.ws-cart-free-gift-popup[data-free-gift-floating-popup="true"].is-active').first();
			if ($activeFloatingPopup.length) {
				var entry = $activeFloatingPopup.attr('data-free-gift-entry') || '';
				var $freshFloatingPopup = $newPopup.clone()
					.attr('data-free-gift-floating-popup', 'true')
					.addClass('is-active')
					.attr('aria-hidden', 'false');
				if (entry) {
					$freshFloatingPopup.attr('data-free-gift-entry', entry);
				}
				$activeFloatingPopup.replaceWith($freshFloatingPopup);
			}
			var $floatingPopup = $('.ws-cart-free-gift-popup[data-free-gift-floating-popup="true"]');
			cartFn.syncFreeGiftCurrencyState($sections);
			if ($floatingPopup.length) {
				cartFn.syncFreeGiftCurrencyState($floatingPopup);
			}
			return true;
		},
		// 外部入口打开后后台刷新一次弹窗，确保 $400 门槛、已选礼品和 line key 维持最新。
		refreshFreeGiftScopedPopup: function ($trigger, callback) {
			var $scope = $trigger && $trigger.closest('.ws-product__basic-info-wrapper, .section-westyle-free-gift-fab, .ws-complete-the-look-wrapper');
			if (!$scope || !$scope.length) {
				callback && callback();
				return;
			}
			if ($scope.attr('data-free-gift-popup-loading') === 'true') return;
			$scope.attr('data-free-gift-popup-loading', 'true');
			WS.ajax({
				url: WS.ui.routes.getCartListUrl,
				dataType: 'html',
				success: function (res) {
					var responseHTML = cartFn.extractCartSectionHtml(res, 'westyle-cart');
					cartFn.syncFreeGiftPopupFromHtml(responseHTML, $scope);
				},
				complete: function () {
					$scope.removeAttr('data-free-gift-popup-loading');
					callback && callback();
				}
			});
		},
		// PDP 父级存在 transform / overflow，fixed 弹窗放在模块内会被限制；打开时克隆到 body 保证全屏。
		mountFreeGiftPopupForViewport: function ($popup) {
			if (!$popup || !$popup.length) return $();
			if ($popup.attr('data-free-gift-floating-popup') === 'true' || $popup.parent().is('body')) return $popup;
			$('.ws-cart-free-gift-popup[data-free-gift-floating-popup="true"]').remove();
			var $floatingPopup = $popup.clone().attr('data-free-gift-floating-popup', 'true');
			$('body').append($floatingPopup);
			return $floatingPopup;
		},
		// 区分弹窗入口：购物车内触发时 PC 高度略矮，PDP / FAB 等入口保持 100% 高度。
		getFreeGiftPopupEntry: function ($trigger) {
			return $trigger && $trigger.closest('#cartform, .cart-drawer_container_content, #cart-template, .cart-drawer_container').length
				? 'cart'
				: 'default';
		},
		// 打开 Free Gift 选择弹窗。其他入口只需要添加 data-open-free-gift-popup。
		openFreeGiftPopup: function ($trigger) {
			var $popup = cartFn.findFreeGiftPopupForTrigger($trigger);
			if (!$popup.length) return;
			$popup = cartFn.mountFreeGiftPopupForViewport($popup);
			cartFn.syncFreeGiftCurrencyState($popup);
			$popup.attr('data-free-gift-entry', cartFn.getFreeGiftPopupEntry($trigger));
			$popup.addClass('is-active').attr('aria-hidden', 'false');
			WS.ui.operateZeSnippet && WS.ui.operateZeSnippet(1);
			WS.ui.popupNoScrollHandle && WS.ui.popupNoScrollHandle();
		},
		// 关闭弹窗；如果购物车抽屉仍打开，不恢复 body 滚动，避免抽屉滚动状态被打断。
		closeFreeGiftPopup: function (options) {
			options = options || {};
			var $popup = $('.ws-cart-free-gift-popup.is-active').first();
			if (!$popup.length) return;
			if ($popup.attr('data-free-gift-floating-popup') === 'true') {
				$popup.remove();
			} else {
				$popup.removeClass('is-active').attr('aria-hidden', 'true');
			}
			if (!$('.cart-drawer_container').hasClass('is-visible')) {
				WS.ui.popupRecoveryScrollHandle && WS.ui.popupRecoveryScrollHandle();
				if (options.keepZeSnippetHidden !== true) {
					WS.ui.operateZeSnippet && WS.ui.operateZeSnippet(2);
				}
			}
		},
		// Free Gift Terms 使用独立弹窗，避免跳转通用 Terms 页面。
		ensureFreeGiftTermsPopup: function () {
			var $popup = $('#ws-free-gift-terms-popup');
			if ($popup.length) return $popup;
			var html = [
				'<div class="ws-free-gift-terms-popup" id="ws-free-gift-terms-popup" aria-hidden="true" inert>',
					'<div class="ws-free-gift-terms-popup__overlay" data-close-free-gift-terms></div>',
					'<div class="ws-free-gift-terms-popup__panel" role="dialog" aria-modal="true" aria-labelledby="ws-free-gift-terms-title">',
						'<button type="button" class="ws-free-gift-terms-popup__close" data-close-free-gift-terms aria-label="Close Free Gift Terms"><span aria-hidden="true"></span></button>',
						'<h2 class="ws-free-gift-terms-popup__title" id="ws-free-gift-terms-title">Free Gift Terms</h2>',
						'<div class="ws-free-gift-terms-popup__body">',
							'<p>Spend $400+ USD after discounts and choose one free gift from our selected gift collection.</p>',
							'<p>Order minimum excludes shipping, taxes, gift cards, and the value of the gift. Limit one free gift per qualifying order. Available while supplies last.</p>',
							'<p>If you return your order, the free gift must also be returned. If the gift is not returned, its retail value will be deducted from your refund.</p>',
							'<p class="ws-free-gift-terms-popup__contact">Got questions? Drop us a line at<br><a href="mailto:hello@nanajacqueline.com">hello@nanajacqueline.com</a>.</p>',
						'</div>',
					'</div>',
				'</div>'
			].join('');
			$('body').append(html);
			return $('#ws-free-gift-terms-popup');
		},
		openFreeGiftTermsPopup: function ($trigger) {
			var $popup = cartFn.ensureFreeGiftTermsPopup();
			cartFn._freeGiftTermsOpener = $trigger && $trigger.length ? $trigger[0] : document.activeElement;
			$popup.addClass('is-active').attr('aria-hidden', 'false').removeAttr('inert');
			window.setTimeout(function () {
				$popup.find('.ws-free-gift-terms-popup__close').trigger('focus');
			}, 0);
			WS.ui.popupNoScrollHandle && WS.ui.popupNoScrollHandle();
		},
		closeFreeGiftTermsPopup: function () {
			var $popup = $('#ws-free-gift-terms-popup');
			if (!$popup.length) return;
			var activeEl = document.activeElement;
			if (activeEl && $popup[0].contains(activeEl)) {
				var opener = cartFn._freeGiftTermsOpener;
				if (opener && document.documentElement.contains(opener)) {
					try {
						opener.focus({ preventScroll: true });
					} catch (e) {
						opener.focus();
					}
				} else {
					activeEl.blur();
				}
			}
			cartFn._freeGiftTermsOpener = null;
			$popup.removeClass('is-active').attr('aria-hidden', 'true').attr('inert', '');
			if (!$('.ws-cart-free-gift-popup.is-active').length && !$('.cart-drawer_container').hasClass('is-visible')) {
				WS.ui.popupRecoveryScrollHandle && WS.ui.popupRecoveryScrollHandle();
			}
		},
		// Liquid 只输出实际 $0 赠品 line key，切换时保留同集合里的计费商品。
		getFreeGiftLineKeys: function ($popup) {
			var raw = String(($popup && $popup.attr('data-gift-line-keys')) || '');
			if (!raw) return [];
			return raw.split(',').map(function (key) {
				return $.trim(key);
			}).filter(function (key) {
				return !!key;
			});
		},
		// 外部弹窗不是购物车抽屉的一部分，加购成功后同步按钮状态和 line key，保证后续换礼品仍是单选。
		syncFreeGiftPopupSelection: function (variantId, addedItem) {
			var item = addedItem || {};
			if (typeof item === 'string') {
				try {
					item = JSON.parse(item || 'null') || {};
				} catch (e) {
					item = {};
				}
			}
			var lineKey = item.key || '';
			$('.ws-cart-free-gift-popup').each(function () {
				var $popup = $(this);
				var isUnlocked = $popup.attr('data-unlocked') === 'true';
				if (lineKey) {
					$popup.attr('data-gift-line-keys', lineKey);
				}
				$popup.attr('data-selected-variant-id', variantId);
				$popup.find('.ws-cart-free-gift-popup__choose').each(function () {
					var $btn = $(this);
					var isSelected = String($btn.attr('data-variant-id')) === String(variantId);
					if (isSelected) {
						$btn.addClass('is-selected').removeClass('is-disabled').prop('disabled', true).text('Selected ✓');
					} else if (isUnlocked) {
						$btn.removeClass('is-selected is-disabled').prop('disabled', false).text('Change to this');
					}
				});
			});
		},
		// 添加指定 gift variant。隐藏属性用于和已有计费同款分行，避免 Shopify Ajax cart 自动合并。
		addFreeGiftVariant: function (variantId, onSuccess, onError) {
			WS.ajax({
				url: WS.ui.routes.addCartItemUrl,
				type: 'POST',
				data: {
					id: variantId,
					quantity: 1,
					'properties[_ws_free_gift]': 'true',
					'properties[_ws_free_gift_key]': String(Date.now())
				},
				success: function (res) {
					onSuccess && onSuccess(res);
				},
				error: function (error) {
					onError && onError(error);
				}
			});
		},
		// 选择/切换礼品：先删除购物车已有礼品，再加购新礼品，保证单选。
		replaceFreeGift: function (variantId, $trigger) {
			var $popup = $trigger && $trigger.length ? $trigger.closest('.ws-cart-free-gift-popup') : $('.ws-cart-free-gift-popup').first();
			if (!variantId || !$popup.length) {
				WS.ui.toastShowHandle && WS.ui.toastShowHandle(WS.ui.errorMsgMap.baseError);
				return;
			}
			cartFn.syncFreeGiftCurrencyState($popup);
			if ($popup.attr('data-unlocked') !== 'true') {
				WS.ui.toastShowHandle && WS.ui.toastShowHandle($popup.attr('data-locked-message') || 'Add more to unlock.');
				return;
			}
			if ($popup.attr('aria-busy') === 'true') return;

			$popup.attr('aria-busy', 'true');
			$popup.find('.ws-cart-free-gift-popup__choose').attr('aria-busy', 'true');
			WS.ui.loadingPopShow && WS.ui.loadingPopShow();

			var giftLineKeys = cartFn.getFreeGiftLineKeys($popup);
			var popupEntry = $popup.attr('data-free-gift-entry') || 'default';
			var done = function () {
				$popup.removeAttr('aria-busy');
				$popup.find('.ws-cart-free-gift-popup__choose').removeAttr('aria-busy');
				WS.ui.loadingPopHide && WS.ui.loadingPopHide();
			};
			var handleGiftSuccess = function (addedItem) {
				done();
				cartFn.syncFreeGiftPopupSelection(variantId, addedItem);
				cartFn.closeFreeGiftPopup({ keepZeSnippetHidden: popupEntry !== 'cart' });
				WS.ui.toastShowHandle && WS.ui.toastShowHandle(WS.$t('public.toast.add_succ_toast'));
				if (popupEntry === 'cart') {
					cartFn.request(false, 1);
					return;
				}
				cartFn.handleOpenDrawer ? cartFn.handleOpenDrawer('add_bag') : cartFn.request(false, 1);
			};
			var addSelectedGift = function () {
				cartFn.addFreeGiftVariant(variantId, function (addedItem) {
					handleGiftSuccess(addedItem);
				}, function (error) {
					done();
					try {
						var errorRes = error && error.response ? JSON.parse(error.response) : {};
						WS.ui.toastShowHandle(errorRes.message || WS.ui.errorMsgMap.baseError);
					} catch (err) {
						WS.ui.toastShowHandle && WS.ui.toastShowHandle(WS.ui.errorMsgMap.baseError);
					}
				});
			};

			if (giftLineKeys.length) {
				var updates = {};
				for (var i = 0; i < giftLineKeys.length; i++) {
					updates[giftLineKeys[i]] = 0;
				}
				cartApplyUpdatesPreservingDiscount(updates, function () {
					addSelectedGift();
				}, function () {
					done();
					WS.ui.toastShowHandle && WS.ui.toastShowHandle(WS.ui.errorMsgMap.baseError);
				});
			} else {
				addSelectedGift();
			}
		},
		// 从商品链接中提取 handle，用于拼接 `/products/{handle}?sections=...`。
		// 购物车 item 数据有时没有 handle 字段，所以需要从 href/url 做兜底解析。
		getProductHandleFromUrl: function (url) {
			url = String(url || '');
			if (!url) return '';
			var path = url.split('?')[0].split('#')[0];
			try {
				var link = document.createElement('a');
				link.href = url;
				path = link.pathname || path;
			} catch (e) {}
			var match = path.match(/\/products\/([^\/?#]+)/);
			return match && match[1] ? decodeURIComponent(match[1]) : '';
		},
		// 购物车 Bought Together 的展示条件：
		// 1. 当前在售商品总数量必须等于 1；
		// 2. DOM 中在售商品行也必须只有 1 行；
		// 3. 该商品行自身 quantity 必须等于 1。
		// 这样可以避免“同一商品数量 2 件”或“含售罄商品”等场景误展示推荐模块。
		getSingleActiveCartItemInfo: function () {
			if (Number(originCartNumber) !== 1) return null;
			var $items = $(originCartOnSellItemsDom);
			if ($items.length !== 1) return null;
			var $item = $items.first();
			var itemData = {};
			try {
				itemData = JSON.parse($item.find('.js-product-json').text() || 'null') || {};
			} catch (e) {
				itemData = {};
			}
			if (Number(itemData.quantity || $item.attr('data-quantity') || 0) !== 1) return null;

			var productUrl = $item.find('.cart-info_title a').attr('href') || $item.find('.cart-image_wrapper').attr('href') || '';
			var productId = itemData.productId;
			if (originCartItemList && originCartItemList.length) {
				for (var i = 0; i < originCartItemList.length; i++) {
					var cartItem = originCartItemList[i];
					if (!cartItem) continue;
					if (String(cartItem.product_id || cartItem.productId || '') === String(productId || '')) {
						productUrl = productUrl || cartItem.url || '';
						return {
							productId: productId || cartItem.product_id || cartItem.productId || '',
							handle: cartItem.handle || cartFn.getProductHandleFromUrl(productUrl),
							productUrl: productUrl
						};
					}
				}
			}
			return {
				productId: productId || '',
				handle: itemData.handle || cartFn.getProductHandleFromUrl(productUrl),
				productUrl: productUrl
			};
		},
		// 将商品详情 complete-the-look section 的 HTML 转成购物车 Bought Together 卡片。
		// 注意：
		// - 最多展示 3 个，符合购物车设计；
		// - 克隆卡片时移除曝光/lazyload 已完成标记，插入购物车后重新走曝光和图片懒加载；
		// - 如果 section 没数据或结构异常，直接隐藏模块，不展示空壳。
		renderCartBoughtTogetherFromHtml: function ($module, responseHTML, requestKey) {
			if (!$module || !$module.length || !responseHTML) {
				cartFn.hideCartBoughtTogether($module);
				return;
			}
			var $parsed = $('<div>').html(responseHTML);
			var $blocks = $parsed.find('.ws-complete-the-look-listbox .ws-product-block');
			if (!$blocks.length) {
				$blocks = $parsed.find('.ws-product-block');
			}
			$blocks = $blocks.slice(0, 3);
			if (!$blocks.length) {
				cartFn.hideCartBoughtTogether($module);
				return;
			}

			var $list = $module.find('.ws-featured-collection-product-list').first();
			if (!$list.length) {
				cartFn.hideCartBoughtTogether($module);
				return;
			}
			$list.empty();
			$blocks.each(function () {
				var $block = $(this).clone();
				$block.removeClass('stat-complete').removeAttr('stat-index');
				$block.find('.stat-complete').removeClass('stat-complete').removeAttr('stat-index');
				$block.find('.img-lazyload-complete').removeClass('img-lazyload-complete');
				$list.append($block);
			});
			$module.attr('data-source-key', requestKey || '').css('display', 'flex').addClass('is-active');
			WS.ui.globalListExposureHandle && WS.ui.globalListExposureHandle();
			WS.ui.initImgLazyloadHandle && WS.ui.initImgLazyloadHandle();
			WS.ui.toggleVariantsScrollButtons && WS.ui.toggleVariantsScrollButtons();
		},
		// 拉取当前购物车唯一商品的 complete-the-look section，作为购物车 Bought Together 数据源。
		// 这里用 handle + productId 做缓存 key：同一商品重复刷新购物车时不重复请求；
		// 同时用 cartBoughtTogetherRequestSeq 丢弃旧请求，避免快速加减商品时旧响应覆盖新状态。
		renderCartBoughtTogether: function () {
			var $module = $('#ws-cart-collection');
			if (!$module.length) return;
			cartBoughtTogetherRequestSeq++;
			var requestSeq = cartBoughtTogetherRequestSeq;
			var itemInfo = cartFn.getSingleActiveCartItemInfo();
			if (!itemInfo || !itemInfo.handle) {
				cartFn.hideCartBoughtTogether($module);
				return;
			}

			var requestKey = itemInfo.handle + '|' + (itemInfo.productId || '');
			if (cartBoughtTogetherHtmlCache[requestKey]) {
				cartFn.renderCartBoughtTogetherFromHtml($module, cartBoughtTogetherHtmlCache[requestKey], requestKey);
				return;
			}

			cartFn.hideCartBoughtTogether($module);
			var sectionKey = 'westyle-complete-the-look-data';
			var sectionUrl = WS.site.baseUrl + '/products/' + encodeURIComponent(itemInfo.handle) + '?sections=' + sectionKey;
			WS.ajax({
				url: sectionUrl,
				type: 'GET',
				dataType: 'html',
				success: function (res) {
					if (requestSeq !== cartBoughtTogetherRequestSeq) return;
					var responseHTML = cartFn.extractCartSectionHtml(res, sectionKey);
					if (!responseHTML) {
						cartFn.hideCartBoughtTogether($module);
						return;
					}
					cartBoughtTogetherHtmlCache[requestKey] = responseHTML;
					cartFn.renderCartBoughtTogetherFromHtml($module, responseHTML, requestKey);
				},
				error: function () {
					if (requestSeq !== cartBoughtTogetherRequestSeq) return;
					cartFn.hideCartBoughtTogether($module);
				}
			});
		},
		/**
		 * 判断优惠券是否可用
		 * @param {*} couponItem 
		 * @param {*} cartAmount 
		 * @param {*} cartNumber 
		 * @returns 
		 */
		getCouponVailable: function(couponItem, couponCategory, cartAmount, cartNumber) {
			var discountMinimalPurchaseAmount = couponItem.discountMinimalPurchaseAmount ? Number(couponItem.discountMinimalPurchaseAmount) * WS.site.rate : 0;
			var userCouponType = couponItem.userCouponType;
			var couponMinCount = couponItem.minimalProductCount;
			var redeemCouponAmount = couponItem.redeemCouponAmount;
			// 优惠券折扣金额大于购物车总金额
			if (redeemCouponAmount && Number(redeemCouponAmount) > cartAmount) {
				return false;
			}
			// 用户优惠券类型: userCouponType @unused:1:未使用 @used:2:已使用 @expired:3:已过期
			return userCouponType == 1 // 1未使用
				&& (couponCategory === 1 && discountMinimalPurchaseAmount <= cartAmount) // 满减券
					|| (couponCategory === 2 && couponMinCount <= cartNumber) // 多件梯度券
					|| (couponCategory === 3 && discountMinimalPurchaseAmount === 0); // 无门槛券 
		},
		/**
		 * 优惠券类别
		 * @param {object} couponItem  优惠券数据
		 * @returns 1: 满减券 2: 多件梯度券 3: 无门槛券
		 */
		getCouponCategory: function(couponItem) {
			var discountMinimalPurchaseAmount = couponItem.discountMinimalPurchaseAmount;
			var redeemCouponAmount = couponItem.redeemCouponAmount;
			var couponMinCount = couponItem.minimalProductCount;
			// 如果有category优惠券类别且有minimalProductCount，为多件梯度券
			if (couponMinCount > 0) return 2;
			if (discountMinimalPurchaseAmount && redeemCouponAmount !== '0') return 1;
			if (!discountMinimalPurchaseAmount) return 3;
		},
		/**
		 * 判断当前金额是否达到免邮门槛，返回免邮类型
		 * @param {*} total 匹配金额
		 * @returns
		 */
		handleHasShippingFree: function(total) {
			var standard = countryInfo.standard;
			var express = countryInfo.express;

			// 有快邮门槛且达到快邮门槛
			if (express !== standard && total >= express) {
				return 'Free Express Shipping';
			}
			// 达到平邮门槛
			if (total >= standard) {
				return 'Free Standard Shipping';
			}
			return '';
		},
		/**
		 * 用户输入折扣码并刷新购物车展示（与自动应用共用 /cart/update.js）
		 */
		applyCartDiscountCode: function (code) {
			applyCartDiscountCodeRequest(code, function (ok) {
				if (!ok) return;
				cartFocusAfterUpdate = { selector: '#ws-cart-discount-apply', message: 'Discount code applied.' };
				if (normalizeDiscountCode(code) === normalizeDiscountCode(SUBSCRIBE_DISCOUNT_CODE)) {
					setSubscribeDiscountRemovedByUser(false);
				}
				if (isCouponWhiteListCode(code)) {
					setCouponWhiteListRemovedByUser(code, false);
				}

				if (WS.site.page === 'cart') {
					cartFn.loadCartPage();
				} else {
					cartFn.request(false);
				}
			});
		},
		/**
		 * 仅移除当前点击的折扣码（GET /cart.js → 过滤后 POST discount: '保留码1,码2'；见 Shopify 多码逗号分隔）
		 * @param {string} codeOrTitle 按钮 data-ws-discount-code（与码或展示标题一致，不区分大小写）
		 */
		clearCartDiscountCode: function (codeOrTitle) {
			if (typeof fetch === 'undefined') {
				return;
			}
			var key = String(codeOrTitle || '').trim();
			if (!key) {
				return;
			}
			var base = (typeof WS !== 'undefined' && WS.site && WS.site.baseUrl) ? WS.site.baseUrl : '';
			WS.ui.loadingPopShow && WS.ui.loadingPopShow();
			fetch(base + '/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
				.then(function (r) {
					return r.json();
				})
				.then(function (cart) {
					var nextDiscount = buildRemainingDiscountPayload(cart, key);
					if (nextDiscount === null) {
						restoreSubtotalPopAfterNextBottomRender = false;
						WS.ui.loadingPopHide && WS.ui.loadingPopHide();
						showCartDiscountApplyToast('Could not remove this discount. Please try again.');
						return;
					}
					return fetch(base + '/cart/update.js', {
						method: 'POST',
						credentials: 'same-origin',
						headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
						body: JSON.stringify({ discount: nextDiscount }),
					})
						.then(function (r) {
							return r.text().then(function (text) {
								var body = null;
								try {
									body = text ? JSON.parse(text) : null;
								} catch (e) {
									body = null;
								}
								return { ok: r.ok, status: r.status, body: body };
							});
						})
						.then(function (res) {
							WS.ui.loadingPopHide && WS.ui.loadingPopHide();
							if (cartDiscountApplyFailed(res.ok, res.status, res.body)) {
								restoreSubtotalPopAfterNextBottomRender = false;
								var msg = getCartDiscountApplyErrorMessage(res.body);
								showCartDiscountApplyToast(msg || WS.ui.errorMsgMap.baseError);
								return;
							}

							if (isAutoDiscountCode(key)) {
								setAutoDiscountsRemovedByUser(true);
							}

							if (WS.site.page === 'cart') {
								announceCart('Discount removed.');
								cartFn.loadCartPage();
							} else {
								cartFocusAfterUpdate = { selector: '#ws-cart-discount-input', message: 'Discount removed.' };
								cartFn.request(false);
							}
						});
				})
				.catch(function () {
					restoreSubtotalPopAfterNextBottomRender = false;
					WS.ui.loadingPopHide && WS.ui.loadingPopHide();
					showCartDiscountApplyToast(WS.ui.errorMsgMap.baseError);
				}).finally(function () {
					WS.ui.loadingPopHide && WS.ui.loadingPopHide();
				});
		},
		/**
		 * 购物车侧边栏打开
		 */
		handleOpenDrawer: function (type = '') {
			// type: sale_pop（营销气泡）,nav_icon(导航bagicon）,self_push（自动推出）
			// 赋值来源
			checkoutReportFrom = type;
			if (!$('#cart-drawer').hasClass('is-active')) {
				cartDrawerReturnFocusEl = document.activeElement;
			}
			WS.ui.handleMarketAbtest && WS.ui.handleMarketAbtest();
			if (!$('.cart-drawer_container').hasClass('cart-drawer-loaded')) {
				$("body").append(cartDrawerOuter);
				$('.cart-drawer_container').addClass('cart-drawer-loaded');
			};
			cartFn.request(true);
			// 禁止弹窗底部滚动方法
			WS.ui.popupNoScrollHandle();
			var cartDrawer = $("#cart-drawer");
			$(cartDrawer).addClass("is-active");
			cartDrawer.find('.cart-header__close').trigger('focus');
			setTimeout(function () {
				$(cartDrawer).addClass("is-visible");
				WS.ui.operateZeSnippet(1);
			}, 50);
		},
		/**
		 * 购物车page
		 */
		loadCartPage: function () {
			cartFn.ensureAutoDiscountApplied(function () {
				try {
					WS.ajax({
						url: WS.ui.routes.getCartListUrl,
						dataType: "html",
						success: function (res) {
							WS.ui.handleMarketAbtest && WS.ui.handleMarketAbtest();
							var responseHTML = JSON.parse(res || 'null')["westyle-cart"] || "";
							var container = $(responseHTML).find("#cart-template").html() || "";
							var $cartMain = $(".cart-drawer_container_content");
							var patched = cartFn.tryPatchCartDrawerFromSection($cartMain, responseHTML);
							if (!patched) {
								cartFn.swapCartMainTemplateHtml($cartMain, container, { skipPreserve: false });
								// 整块替换后 Liquid 仍是初始币种判断，需立刻按当前币种重算 Free Gift 锁定状态。
								cartFn.syncFreeGiftCurrencyState($cartMain);
							}
							setTimeout(() => {
								WS.ui.setFirstView();
								WS.ui.setInteractive();
							}, 0);

							cartFn.onShowSubscribeModule();
							cartFn.getCartDataInfo().then(restoreCartFocusAfterUpdate).catch(restoreCartFocusAfterUpdate);
							WS.ui.collectionFn.bindScrollType('cartPage');
						},
						error: function (e) {
						},
					});
				} catch (e) {
				}
			});
		},
		checkoutPreload: function() {
			if (sessionStorage.getItem("checkoutPreload")) return;
			var ifr = `
			<iframe style="width: 1px; height: 1px; opacity: 1;" srcdoc='<!DOCTYPE html><html lang="en"><head>
				<meta charset="UTF-8">
				<meta http-equiv="X-UA-Compatible" content="IE=edge">
				<meta name="viewport" content="width=device-width, initial-scale=1.0">
				<title>checkout preload</title>

				<link rel="stylesheet" href="https://cdn.shopify.com/s/files/1/0568/2895/2624/files/shopify-checkout-style.css?v=1659948245" media="all">
			</head>
			<body>
				<script src="//cdn.shopify.com/app/services/56828952624/javascripts/checkout_countries/123191066672/en-US/countries-c19ab71756a6251e21a59aa97d81ddd5b4659d14-c19ab71756a6251e21a59aa97d81ddd5b4659d14-0-d295b8ba1ab1e296ee2c6d377b1e79b7a1dddd34.js?version=2021-01-25" crossorigin="anonymous"></script>
				<script src="//cdn.shopify.com/shopifycloud/shopify/assets/checkout_2021-01-25-96667d41e7fe5fac4c6033f3d608cb762ee71e5ff16c88b8336bb65f48bcbd46.js" crossorigin="anonymous"></script>
				<script src="//cdn.shopify.com/shopifycloud/shopify/assets/shopify_pay-56e2abe72eaa64df4fb10c9b0f77888826c6d64b62f1ffb3fa8dc9839bb22b08.js" crossorigin="anonymous"></script>
				<script>
					sessionStorage.setItem("checkoutPreload", 1);
				</script>
			</body>
			</html>'></iframe>
		`;
			$('body').append(ifr.replace(/\n/g, ''));
		},
		insertCartBottomList: function() {
			cartFn.renderCartBoughtTogether();
		},
		/**
		 * 获取购物车列表，加载westyle-cart.liquid
		 */
		request: function (firstLoad = false, addBagRequest) {
			var cartLoading = $("#cart-loading");
			var cartContent = $(".cart-drawer_container_content");
			firstLoad && $(cartContent).hide();
			firstLoad && $(cartLoading).show();
			try {
				cartFn.ensureAutoDiscountApplied(function () {
					WS.ajax({
						url: WS.ui.routes.getCartListUrl,
						dataType: "html",
						success: function (res) {
							var responseHTML = JSON.parse(res || 'null')["westyle-cart"] || "";
							cartFn.syncFreeGiftPopupFromHtml(responseHTML);
							var container = $(responseHTML).find("#cart-template").html() || "";
							var patched =
								!firstLoad && cartFn.tryPatchCartDrawerFromSection(cartContent, responseHTML);
							if (!patched) {
								cartFn.swapCartMainTemplateHtml(cartContent, container, {
									skipPreserve: firstLoad,
								});
								// 首次打开抽屉会走整块替换，内容展示前先修正非 USD 下的 Free Gift 文案和按钮状态。
								cartFn.syncFreeGiftCurrencyState(cartContent);
							}
							firstLoad && $(cartLoading).hide();
							firstLoad && cartContent.show();
							cartFn.syncCartDrawerBottomInset(cartContent);
							// 更新头部商品数量
							var count = cartContent.find('#cart-sum').text() || '0';
							var countText = count === '1' ? ' (1 item)' : ' (' + count + ' items)';
							$('#cart-drawer-header-count').text(countText);
							cartFn.onShowSubscribeModule();
							cartFn.getCartDataInfo(2, addBagRequest, '', firstLoad)
								.then(restoreCartFocusAfterUpdate).catch(restoreCartFocusAfterUpdate);
							WS.ui.collectionFn.bindScrollType("drawerCart");
							WS.ui.loadingPopHide();
							WS.ui.reporterCartState();
							setTimeout(function() {
								document.querySelector('#all-cart-items') && document.querySelector('#all-cart-items').addEventListener('touchstart', cartFn.hideCartDetailsPopup, { passive: true });
							}, 50);
							if (firstLoad) {
								var type = checkoutReportFrom == 'self_push' ? WS.ui.reportMap['cartDrawerAutoOpen'] : WS.ui.reportMap['cartDrawerOpen'];
								cartFn.cartReportHandle(WS.ui.reportType['moduleShow'], type, {ext5: checkoutReportFrom});
							}
						},
						error: function (e) {
							WS.ui.loadingPopHide();
						},
					});
				});
			} catch (e) {
			}
		},

		/**
		 * 购物车加减、input blur事件
		 * @param {*} handleType
		 * @param {*} cartId
		 * @param {*} self
		 */
		handleCalc: function (handleType, cartId, self) {
			var ret, $input;
			if (handleType === CHANGE_TYPE) {
				$input = $(self);
				ret = $input.attr("value");
			} else {
				$input = $(self).siblings(".quantity");
				var curVal = Number.parseInt($input.attr("value"));
				if (handleType === INCREASE_TYPE) {
					var increaseResult = canIncreaseCartItem(self, curVal);
					// 不可增加，做提示
					if (!increaseResult.canIncrease) {
						announceCart(WS.$t('bag.inventory_quantity_tip', { inventoryQuantity: increaseResult.maxQuantity }));
						WS.ui.toastShowHandle(
							WS.$t('bag.inventory_quantity_tip', { inventoryQuantity: increaseResult.maxQuantity })
						);
						return;
					}
					ret = curVal + 1;
					WS.ui.reporterSingle(WS.ui.reportMap['increaseCartItemQuantity'], self);
				} else {
					ret = curVal - 1;
					if (ret < 1) {
						cartFocusAfterUpdate = { selector: '.minus-btn', variantId: String(cartId), message: 'Item removed from cart.' };
						cartFn._delItem(cartId, self);
						return;
					}
					WS.ui.reporterSingle(WS.ui.reportMap['minusCartItemQuantity'], self);
				}
			}
			try {
				cartFocusAfterUpdate = { selector: handleType === INCREASE_TYPE ? '.increase-btn' : '.minus-btn', variantId: String(cartId), message: 'Quantity updated to ' + ret + '.' };
				WS.ui.loadingPopShow && WS.ui.loadingPopShow();
				WS.ajax({
					url: WS.ui.routes.changeCarItemtUrl,
					type: "POST",
					data: {
						id: cartId,
						quantity: ret,
					},
					success: function () {
						cartFn.request(false, 1);
					},
					error: function (e) {
							cartFocusAfterUpdate = null;
							announceCart(WS.ui.errorMsgMap.baseError);
							WS.ui.toastShowHandle(WS.ui.errorMsgMap.baseError);
					},
					complete: function () {
						WS.ui.loadingPopHide && WS.ui.loadingPopHide();
					}
				});
			} catch (e) {
				WS.ui.loadingPopHide && WS.ui.loadingPopHide();
			}
			
		},

		/**
		 * 加购时是否弹出侧边栏购物车方法
		 */
		addBagPopupDrawer: function (totalPrice) {
			// 判断加购时，是否弹出侧边栏购物车
			var getLsCartCookie = WS.cookie.get("graecove-show-cartDrawer")
				? JSON.parse(WS.cookie.get("graecove-show-cartDrawer") || 'null')
				: { standard: false, express: false };
			// 判断当前国家对应的免邮金额
			// 当金额到达时
			if (
				(totalPrice >= countryInfo.standard && !getLsCartCookie.standard) ||
				(totalPrice >= countryInfo.express && !getLsCartCookie.express)
			) {
				if (window.location.href.search("cart") == -1) {
					// 储存一天的cookie，一天只弹出一次
					var ls_cookie_info = {
						standard: totalPrice >= countryInfo.standard ? true : false,
						express:
							totalPrice >= countryInfo.express || !countryInfo.express
								? true
								: false,
					};
					WS.cookie.set(
						"graecove-show-cartDrawer",
						JSON.stringify(ls_cookie_info),
						24
					);
					// 打开侧边栏购物车
					cartFn.handleOpenDrawer('self_push');
					// 去除abt顶部营销弹窗模块
          $('.ws-market-checkout-tipimg-abt').remove();
					// 展示提示文案
					WS.ui.toastShowHandle(WS.$t('public.toast.free_shipping_toast', '', 1));
				}
			}
		},
		// 价格格式: $950.00 USD (symbol + amount + space + currency)
		_fmtPrice: function (value) {
			var symbol = (typeof WS.site !== 'undefined' && WS.site.symbol) ? WS.site.symbol : (countryInfo && countryInfo.symbol) ? countryInfo.symbol : '$';
			var currency = (typeof WS.site !== 'undefined' && WS.site.currency) ? WS.site.currency : 'USD';
			return symbol + WS.i18n.fmtAmount(Number(value).toFixed(2)) + ' ' + currency;
		},
		// 购物车底部checkout区域abt方法
		cartBottomCheckoutModelHanlde: function (firstLoad) {
			$("#btn-wrapper-pop-abt > .btn-wrapper-pop-abt-content").remove();
			$("#cart-discount-module-wrapper").remove();
			var cartDetailInfo = {
				subTotal: originCartSubtotal || originCartAmount,
				totalDiscount: originCartTotalDiscount,
				isSubscribe: WS.ui.subscribeModuleFn.isSubscribed,
				shippingStatus: 1,
				isShowSubscribeModule: isShowSubscribeModule && !cartFn.cartSnapshotHasApplicableDiscounts(),
			};
			var cartBottomPriceDetailHtmlStr = WS.tmpl(cartBottomPriceDetailModel, cartDetailInfo);
			// cartFn.changeFinalCartTotalDisplay(cartTotal);

			$("#btn-wrapper-pop-abt").append(cartBottomPriceDetailHtmlStr);

			// 添加购物车折扣标签html
			$("#discount-tags-wrapper").html(originCartDiscountTagsHtml);

				cartFn.initShoppingSecuritySlider();

				// 活动文案开启时，底部区域只允许展示 campaign message：
				// - 隐藏/移除订阅折扣条 cart-discount-module-wrapper，避免和活动条同时出现；
				// - 小计详情层保持收起，避免缩放或局部刷新后露出旧的折扣文案；
				// - 非活动状态才初始化原来的订阅折扣条逻辑。
				var hasCampaignMessage = $('.cart-bottom_wrapper > .ws-shopping-security--campaign, #btn-wrapper-pop-abt > .ws-shopping-security--campaign').length > 0;
			if (hasCampaignMessage) {
				$('.cart-discount-module-wrapper').hide();
				$('#cart-discount-module-wrapper').remove();
				restoreSubtotalPopAfterNextBottomRender = false;
				cartFn.applySubtotalPopOpenState(false);
			} else {
				cartFn.initCartDiscountModule();
			}

			if (
				!hasCampaignMessage &&
				$('#btn-wrapper-pop-abt').length &&
				!$('#btn-wrapper-pop-abt').hasClass('btn-wrapper-pop-abt-active') &&
				WS.ui.subscribeModuleFn &&
				!WS.ui.subscribeModuleFn.isSubscribed &&
				!cartFn.cartSnapshotHasApplicableDiscounts() &&
				isShowSubscribeModule
			) {
				$('#ws-shopping-cart-free-shipping-module-content').css('display', 'none');
				$('#ws-shopping-cart-discount-module-wrapper').css('display', 'flex');
				requestAnimationFrame(function () {
					cartFn.scheduleFitCartDiscountModuleText();
				});
			}

			if (!hasCampaignMessage && restoreSubtotalPopAfterNextBottomRender) {
				restoreSubtotalPopAfterNextBottomRender = false;
				if ($('#btn-wrapper-pop-abt').length) {
					cartFn.applySubtotalPopOpenState(true);
				}
			}

			if ($('#btn-wrapper-pop-abt').hasClass('btn-wrapper-pop-abt-active')) {
				cartFn.cartReportHandle(WS.ui.reportType['moduleShow'], WS.ui.globalReportMap['showSubtotalPop'], {ext5: 'nav_icon'});
			}
			},
			initCartDiscountModule: function (isUseSubscribeDiscount = false) {
				// 活动文案优先级高于订阅折扣条。
				// 即使外部流程误调用 initCartDiscountModule，也在入口处兜底隐藏，保证 campaign_message_enabled 开启时不展示 cart-discount-module-wrapper。
				if ($('.cart-bottom_wrapper > .ws-shopping-security--campaign, #btn-wrapper-pop-abt > .ws-shopping-security--campaign').length) {
					$('.cart-discount-module-wrapper').hide();
					return;
				}
				var cartDiscountModuleWrapper = $('#cart-discount-module-wrapper');
				var cartDiscountModuleLabel = $('#cart-discount-module-label');
				var cartDiscountModuleTextHtml = $('#cart-discount-module-text-html');

			var wsShoppingCartDiscountModuleLabel = $('#ws-shopping-cart-discount-module-label');
			var wsShoppingCartDiscountModuleTextHtml = $('#ws-shopping-cart-discount-module-text-html');
			var labelText = '';
			var discountTextHtml = '';

			if (
				!WS.ui.subscribeModuleFn.isSubscribed &&
				!cartFn.isAutoApplySubscribeDiscount() &&
				cartFn.cartSnapshotHasApplicableDiscounts()
			) {
				$('.cart-discount-module-wrapper').hide();
				return;
			}

			// 已使用过订阅折扣
			if (isUseSubscribeDiscount) {
				// discountTextHtml = `
				// 	<span class="cart-discount-module__discount-value">This email has already used the first-order offer.</span>
				// `
				// cartDiscountModuleLabel.text('First-order offer already used');
				// cartDiscountModuleTextHtml.html(discountTextHtml);
				// // 新版UI老客不展示模块
				cartDiscountModuleWrapper.hide();
				return;
			}

			// 未订阅且需要展示订阅模块
			if (!WS.ui.subscribeModuleFn.isSubscribed && isShowSubscribeModule) {
				discountTextHtml = `
					Save <span class="cart-discount-module__discount-value">${WS.ui.formatPrice(subscribeDiscount)}</span> Now → 
				`
				labelText = 'New Customers: 15% off';
			}

			// 已订阅且自动应用订阅折扣
			if (cartFn.isAutoApplySubscribeDiscount()) {
				discountTextHtml = `
					Now only <span class="cart-discount-module__discount-value">${WS.ui.formatPrice(subscribeDiscount)}</span>
				`
				labelText = 'First-order 15% off applied.';
			}

			cartDiscountModuleLabel.text(labelText);
			cartDiscountModuleTextHtml.html(discountTextHtml);

			wsShoppingCartDiscountModuleLabel.text(labelText);
			wsShoppingCartDiscountModuleTextHtml.html(discountTextHtml);

			requestAnimationFrame(function () {
				requestAnimationFrame(function () {
					cartFn.fitCartDiscountModuleText();
				});
			});
		},

		/**
		 * 折扣条左右 #cart-discount-module-label / #cart-discount-module-text-html 等：单行，宽度不足时在约 65%～100% 设计字号内缩小
		 */
		fitCartDiscountModuleText: function () {
			var labelIds = ['cart-discount-module-label', 'ws-shopping-cart-discount-module-label'];
			var discountIds = ['cart-discount-module-text-html', 'ws-shopping-cart-discount-module-text-html'];
			var allIds = labelIds.concat(discountIds);
			var i;
			for (i = 0; i < allIds.length; i++) {
				var clearEl = document.getElementById(allIds[i]);
				if (clearEl) clearEl.style.removeProperty('font-size');
			}

			function fitOne(el) {
				if (!el) return;
				if (!String(el.textContent || '').replace(/\s/g, '')) return;
				if (!el.clientWidth) return;
				var cs = window.getComputedStyle(el);
				var maxFont = parseFloat(cs.fontSize);
				if (!maxFont || isNaN(maxFont)) {
					maxFont = 13;
				}
				if (el.scrollWidth <= el.clientWidth) return;
				var minFont = Math.max(9, maxFont * 0.65);
				var low = minFont;
				var high = maxFont;
				var best = minFont;
				var guard = 0;
				while (high - low > 0.25 && guard < 28) {
					guard++;
					var mid = (low + high) / 2;
					el.style.fontSize = mid + 'px';
					if (el.scrollWidth <= el.clientWidth) {
						best = mid;
						low = mid;
					} else {
						high = mid;
					}
				}
				el.style.fontSize = best + 'px';
			}

			for (i = 0; i < labelIds.length; i++) {
				fitOne(document.getElementById(labelIds[i]));
			}
			for (i = 0; i < discountIds.length; i++) {
				fitOne(document.getElementById(discountIds[i]));
			}
		},

		scheduleFitCartDiscountModuleText: function () {
			var self = this;
			if (fitCartDiscountModuleTextTimer) clearTimeout(fitCartDiscountModuleTextTimer);
			fitCartDiscountModuleTextTimer = setTimeout(function () {
				fitCartDiscountModuleTextTimer = null;
				self.fitCartDiscountModuleText();
			}, 120);
		},

		// 底部 Free Gift + checkout 固定区高度会变化，滚动容器需同步留白，避免最后商品被盖住。
		syncCartDrawerBottomInset: function ($scope) {
			var $root = $scope && $scope.length ? $scope : $('.cart-drawer_container');
			var $drawer = $root.closest('.cart-drawer_container');
			if (!$drawer.length) {
				$drawer = $('.cart-drawer_container').first();
			}
			var $contentWrapper = $drawer.find('.cart-drawer_container_content-wrapper').first();
			var $bottom = $contentWrapper.find('.cart-bottom_wrapper').first();
			if (!$contentWrapper.length || !$bottom.length) return;

			requestAnimationFrame(function () {
				requestAnimationFrame(function () {
					var bottomEl = $bottom[0];
					var bottomHeight = bottomEl ? Math.ceil(bottomEl.getBoundingClientRect().height) : 0;
					if (bottomEl && window.getComputedStyle) {
						var bottomStyle = window.getComputedStyle(bottomEl);
						bottomHeight += parseFloat(bottomStyle.marginTop) || 0;
						bottomHeight += parseFloat(bottomStyle.marginBottom) || 0;
					}
					if (!bottomHeight) return;
					$contentWrapper.css('--ws-cart-bottom-inset', (bottomHeight + 24) + 'px');
				});
			});
		},

		initShoppingSecuritySlider: function () {
			var el = document.querySelector('.ws-shopping-security:not([data-slider-inited])');
			if (!el || typeof WS === 'undefined' || !WS.Slider) return;
			// 活动文案是单条静态内容，不需要初始化原来的营销轮播。
			// 这里仍设置 data-slider-inited，避免后续重复扫描同一个节点。
			if (el.classList.contains('ws-shopping-security--campaign')) {
				el.setAttribute('data-slider-inited', '1');
				return;
			}
			var container = el.querySelector('.ws-shopping-security__container');
			var inner = el.querySelector('.ws-shopping-security__inner');
			var slides = inner ? inner.querySelectorAll('.ws-shopping-security__slide') : [];
			if (!container || !inner || slides.length < 2) return;
			el.setAttribute('data-slider-inited', '1');
			var containerId = 'ws-shopping-security-' + Date.now();
			container.id = containerId;
			new WS.Slider({
				container: '#' + containerId,
				wrapper: '.ws-shopping-security__inner',
				slide: '.ws-shopping-security__slide',
				direction: 'y',
				isLoop: true,
				isAuto: true,
				slideSpeed: 300,
				autoInter: 4000
			});
		},

		/**
		 * 购物车顶部提示区域方法
		 */
		cartTopModelHanlde: function (cartTotal) {
			if ( WS.cookie.get('graecove_token') && WS.userVipInfo && WS.userVipInfo.userCurrentVip) {
				var topLoginHtml = `
					<div class="tip-box-inner"><p class="tip-box-item p1">${ WS.$t('bag.order_get_points', { point: (cartTotal*WS.site.rate*WS.userVipInfo.userCurrentVip.consumeRewardPoints).toFixed(0) }, 1) }</p></div>
				`;
				$(".cart-user-point-shipping .tip-box").show();
				$(".cart-user-point-shipping .tip-box").html(topLoginHtml);
			} else {
				var isShowMarketingTip = true;
				if (isShowMarketingTip) {
					$(".cart-user-point-shipping .tip-box").show();
					$(".cart-user-point-shipping .tip-box").html(
						`
						<div class="tip-box-inner">
							<p class="tip-box-item p1">· Buy <span class="sp1">2</span> Get 20% Off, Code: <span class="sp1">SA20</span></p>
							<p class="tip-box-item p1">· Buy <span class="sp1">3</span> Get 25% Off, Code: <span class="sp1">SA25</span></p>
							<p class="tip-box-item p1">· Buy <span class="sp1">4</span> Get 30% Off, Code: <span class="sp1">SA30</span></p>
						</div>
						`);
				} else {
					$(".cart-user-point-shipping .tip-box").remove();
				}
			}
			var tipBoxInnerDom = $('.tip-box .p1');
			if (tipBoxInnerDom.length > 1) {
				new WS.Slider({
					container: ".tip-box",
					wrapper: ".tip-box-inner",
					slide: ".tip-box-item",
					direction: 'x',
					isLoop: true,
					isAuto: true,
					slideSpeed: 300,
					autoInter: 4000
				});
			}
		},
		hideCartDetailsPopup: function(type) {
			// 判断是否打开弹窗
			if ( $('.saving-triangle').hasClass('saving-triangle-active') ) {
				cartFn.applySubtotalPopOpenState(false);
				// 上报
				cartFn.cartReportHandle(WS.ui.reportType['click'], type === '1' ? WS.ui.globalReportMap['clickDownArrowTopSubtotalPop'] : WS.ui.globalReportMap['clickBlankSubtotalPop'])
			}
		},
		/**
		 * 小计详情弹层（btn-wrapper-pop-abt）展开/收起，与 .btn-wrapper-right 点击逻辑一致
		 */
		applySubtotalPopOpenState: function (isOpen) {
			$('.btn-wrapper-right').attr('aria-expanded', isOpen ? 'true' : 'false').attr('aria-label', isOpen ? 'Hide order total breakdown' : 'Show order total breakdown');
			var $wrap = $('.cart-drawer_container_content-wrapper');			
			if (isOpen) {
				if ($wrap.length) {
					$wrap.css('overflow-y', 'hidden');
				}
				$('.saving-triangle').addClass('saving-triangle-active');
				$('#btn-wrapper-pop-abt').addClass('btn-wrapper-pop-abt-active');
				$('#ws-shopping-cart-free-shipping-module-content').css('display', 'flex');
				$('#ws-shopping-cart-discount-module-wrapper').css('display', 'none');
			} else {
				if ($wrap.length) {
					$wrap.css('overflow-y', 'scroll');
				}
				$('.saving-triangle').removeClass('saving-triangle-active');
				$('#btn-wrapper-pop-abt').removeClass('btn-wrapper-pop-abt-active');
				if (!WS.ui.subscribeModuleFn.isSubscribed && !cartFn.cartSnapshotHasApplicableDiscounts() && isShowSubscribeModule) {
					$('#ws-shopping-cart-free-shipping-module-content').css('display', 'none');
					$('#ws-shopping-cart-discount-module-wrapper').css('display', 'flex');
					requestAnimationFrame(function () {
						cartFn.scheduleFitCartDiscountModuleText();
					});
				} else {
					$('#ws-shopping-cart-free-shipping-module-content').css('display', 'flex');
					$('#ws-shopping-cart-discount-module-wrapper').css('display', 'none');
				}
			}
			cartFn.syncCartDrawerBottomInset();
		},
		/**
		 * 整段替换 #cart-template 内层 HTML；skipPreserve 为 true 时不保留小计弹层状态（首次打开）
		 */
		swapCartMainTemplateHtml: function ($cartContent, containerHtml, options) {
			options = options || {};
			var skipPreserve = options.skipPreserve === true;
			var preserveSubtotalPop = null;
			if (!skipPreserve && $cartContent.find('#btn-wrapper-pop-abt').length) {
				preserveSubtotalPop = $cartContent.find('#btn-wrapper-pop-abt').first().hasClass('btn-wrapper-pop-abt-active');
			}
				$cartContent.addClass('ws-updating-cart-drawer-content');
				$cartContent.html(containerHtml);
				// 整段替换购物车 HTML 时，如果新内容已经是活动文案状态，
				// 不继承替换前的小计弹层展开状态，避免缩放/重绘后重新露出旧折扣条或旧文案。
				if ($cartContent.find('.ws-shopping-security--campaign').length) {
					preserveSubtotalPop = false;
				}
			if (preserveSubtotalPop !== null) {
				cartFn.applySubtotalPopOpenState(preserveSubtotalPop);
			}
			cartFn.syncPickAnyTwoGuidance($cartContent);
			requestAnimationFrame(function () {
				requestAnimationFrame(function () {
					$cartContent.removeClass('ws-updating-cart-drawer-content');
				});
			});
		},
		/**
		 * firstLoad 为 false 时：仅替换列表区 + 底部金额条，不替换 #btn-wrapper-pop-abt，保持小计弹层展开状态与 DOM 节点
		 * 空车↔有货、结构不一致时返回 false，由 swapCartMainTemplateHtml 整段替换
		 */
		tryPatchCartDrawerFromSection: function ($cartContent, responseHTML) {
			var inner = '';
			try {
				inner = $(responseHTML).find('#cart-template').html() || '';
			} catch (e) {
				return false;
			}
			if (!inner) return false;
			var $tpl = $('<div>').html(inner);
			var newHasForm = $tpl.find('#cartform').length > 0;
			var oldHasForm = $cartContent.find('#cartform').length > 0;
			if (newHasForm !== oldHasForm) return false;
			if (!newHasForm) return false;

			var $newForm = $tpl.find('#cartform').first();
			var $newPickAnyTwoNav = $tpl.find('.ws-pick-any-two-nav').first();
			var $newItemList = $newForm.find('.cart-item-list').first();
			var $newUserShipping = $newForm.find('.cart-user-point-shipping').first();
			var $newWs = $newForm.find('#ws-cart-content').first();
			var $newBottomSecurity = $newForm.find('.cart-bottom_wrapper > .ws-shopping-security').first();
			var $newPopupSecurity = $newForm.find('#btn-wrapper-pop-abt > .ws-shopping-security').first();
			var $newFreeGift = $newForm.find('.cart-bottom_wrapper > .ws-cart-free-gift').first();
			var $newPopupFreeGift = $newForm.find('#btn-wrapper-pop-abt > .ws-cart-free-gift').first();
			var $newFreeGiftPopup = $newForm.find('.ws-cart-free-gift-popup').first();
			if (!$newItemList.length) return false;

			// 局部刷新只替换购物车列表和底部金额区域，原先不会替换 security DOM。
			// 活动文案和 Free Gift 进度依赖最新购物车数据，所以这里同步替换上下两处 security 和 gift DOM。
			var hasCampaignMessage = $newBottomSecurity.hasClass('ws-shopping-security--campaign') || $newPopupSecurity.hasClass('ws-shopping-security--campaign');
			var wasPopOpen = hasCampaignMessage ? false : $cartContent.find('#btn-wrapper-pop-abt').hasClass('btn-wrapper-pop-abt-active');

			$cartContent.addClass('ws-updating-cart-drawer-content');
			var $oldPickAnyTwoNav = $cartContent.find('.ws-pick-any-two-nav').first();
			if ($newPickAnyTwoNav.length) {
				if ($oldPickAnyTwoNav.length) {
					$oldPickAnyTwoNav.replaceWith($newPickAnyTwoNav.clone());
				} else {
					$cartContent.find('.ws-cart-container > #cartform').first().before($newPickAnyTwoNav.clone());
				}
			} else if ($oldPickAnyTwoNav.length) {
				$oldPickAnyTwoNav.remove();
			}

			if ($newUserShipping.length && $cartContent.find('.cart-user-point-shipping').length) {
				$cartContent.find('.cart-user-point-shipping').first().replaceWith($newUserShipping.clone());
			}
			$cartContent.find('.cart-item-list').first().replaceWith($newItemList.clone());
			if ($newBottomSecurity.length && $cartContent.find('.cart-bottom_wrapper > .ws-shopping-security').length) {
				$cartContent.find('.cart-bottom_wrapper > .ws-shopping-security').first().replaceWith($newBottomSecurity.clone());
			}
			var $oldFreeGift = $cartContent.find('.cart-bottom_wrapper > .ws-cart-free-gift').first();
			if ($newFreeGift.length) {
				if ($oldFreeGift.length) {
					$oldFreeGift.replaceWith($newFreeGift.clone());
				} else {
					var $oldCartBottomFreeGiftSlot = $cartContent.find('.cart-bottom_wrapper').first();
					if ($oldCartBottomFreeGiftSlot.length) {
						$oldCartBottomFreeGiftSlot.prepend($newFreeGift.clone());
					}
				}
			} else if ($oldFreeGift.length) {
				$oldFreeGift.remove();
			}
			var $oldPopupFreeGift = $cartContent.find('#btn-wrapper-pop-abt > .ws-cart-free-gift').first();
			if ($newPopupFreeGift.length) {
				if ($oldPopupFreeGift.length) {
					$oldPopupFreeGift.replaceWith($newPopupFreeGift.clone());
				} else {
					var $oldSubtotalPop = $cartContent.find('#btn-wrapper-pop-abt').first();
					if ($oldSubtotalPop.length) {
						$oldSubtotalPop.prepend($newPopupFreeGift.clone());
					}
				}
			} else if ($oldPopupFreeGift.length) {
				$oldPopupFreeGift.remove();
			}
			// Free Gift 弹窗依赖最新购物车状态（是否解锁、已选礼品 line key），局部刷新时一起同步。
			var $oldFreeGiftPopup = $cartContent.find('.ws-cart-free-gift-popup').first();
			if ($newFreeGiftPopup.length) {
				if ($oldFreeGiftPopup.length) {
					$oldFreeGiftPopup.replaceWith($newFreeGiftPopup.clone());
				} else {
					var $oldCartBottom = $cartContent.find('.cart-bottom_wrapper').first();
					if ($oldCartBottom.length) {
						$oldCartBottom.after($newFreeGiftPopup.clone());
					}
				}
			} else if ($oldFreeGiftPopup.length) {
				$oldFreeGiftPopup.remove();
			}
			if ($newPopupSecurity.length && $cartContent.find('#btn-wrapper-pop-abt > .ws-shopping-security').length) {
				$cartContent.find('#btn-wrapper-pop-abt > .ws-shopping-security').first().replaceWith($newPopupSecurity.clone());
			}
			if ($newWs.length && $cartContent.find('#ws-cart-content').length) {
				$cartContent.find('#ws-cart-content').first().replaceWith($newWs.clone());
			}

			cartFn.syncFreeGiftCurrencyState($cartContent);
			cartFn.syncPickAnyTwoGuidance($cartContent);
			cartFn.applySubtotalPopOpenState(wasPopOpen);

			requestAnimationFrame(function () {
				requestAnimationFrame(function () {
					$cartContent.removeClass('ws-updating-cart-drawer-content');
				});
			});

			return true;
		},
		// changeFinalCartTotalDisplay: function(finalCartAmount) {
		// 	var finalCartAmountStr = cartFn._fmtPrice(finalCartAmount);
		// 	var cartTotalDom = $('.btn-wrapper-abt').find('#cart-total');
		// 	cartTotalDom.text(finalCartAmountStr);
		// 	cartTotalDom.attr('data-findal-cart-amount', finalCartAmount);
		// },
		/**
		 * 事件集合
		 */
		bindEvent: function () {
			if (typeof window !== 'undefined') {
				$(window).on('resize', function () {
					cartFn.scheduleFitCartDiscountModuleText();
					cartFn.syncCartDrawerBottomInset();
				});
			}

			// 购物车优惠提示推出
			$(document).on('click', '.cart-discount-module_register-btn', function() {
				WS.ui.dynamicInsertModuleFn.createSubscribePopupAbt(0, true, 1, '0', 'showJoinCollectivePopClcDiscoutTipsBag');
				sessionStorage.setItem('login_register_source', WS.ui.loginRegisterSourceFieldsMap['cart_guide']);
			});

			$(document).on('click', '.add-product-tip_close', function(e) {
				e.preventDefault();
        $('.add-product-tip-wrapper_bottom').length && $('.add-product-tip-wrapper_bottom').remove();
				// 上报
				var params = JSON.stringify(JSON.parse($('#product-page .stat-ext2').text()));
				var ext1 = $(this).hasClass('produc-discount-tip_left-close-icon') ? WS.ui.userSubscriptionReportMap['closeBotDiscountTip'] : WS.ui.userSubscriptionReportMap['clickIcCloseBottomDiscountTipsProduct'];
        WS.stat({
					eid: WS.ui.reportType['click'],
					ext1: ext1,
					ext2: params,
					ext3: $('.add-product-tip-wrapper_bottom').text()
				});
      });

			$(document).on('click', '.cart-popup-detaiws-btn', function() {
				cartFn.hideCartDetailsPopup('1');
			});

			$(document).on('click', '[data-open-free-gift-popup], .cart-free-gift-change', function(e) {
				e.preventDefault();
				e.stopPropagation();
				var $trigger = $(this);
				if ($trigger.closest('.ws-free-gift-fab, .ws-complete-look-free-gift, .product-free-gift-trigger').length) {
					if (cartFn.findFreeGiftPopupForTrigger($trigger).length) {
						cartFn.openFreeGiftPopup($trigger);
						cartFn.refreshFreeGiftScopedPopup($trigger);
					} else {
						cartFn.refreshFreeGiftScopedPopup($trigger, function () {
							cartFn.openFreeGiftPopup($trigger);
						});
					}
					return;
				}
				cartFn.openFreeGiftPopup($trigger);
			});

			$(document).on('keydown', '.ws-cart-free-gift__view-all-item[data-open-free-gift-popup]', function(e) {
				if (e.key !== 'Enter' && e.key !== ' ') return;
				e.preventDefault();
				$(this).trigger('click');
			});

			$(document).on('click', '[data-close-free-gift-popup]', function(e) {
				e.preventDefault();
				cartFn.closeFreeGiftPopup();
			});

			$(document).on('click', '.ws-cart-free-gift-popup__terms', function(e) {
				e.preventDefault();
				cartFn.openFreeGiftTermsPopup($(this));
			});

			$(document).on('click', '[data-close-free-gift-terms]', function(e) {
				e.preventDefault();
				cartFn.closeFreeGiftTermsPopup();
			});

			$(document).on('keydown', function(e) {
				if (e.key === 'Escape' && $('#ws-free-gift-terms-popup').hasClass('is-active')) {
					cartFn.closeFreeGiftTermsPopup();
				}
			});

			$(document).on('click', '.ws-cart-free-gift-popup__choose', function(e) {
				e.preventDefault();
				var $btn = $(this);
				if ($btn.prop('disabled') || $btn.attr('data-locked') === 'true') {
					var $popup = $btn.closest('.ws-cart-free-gift-popup');
					WS.ui.toastShowHandle && WS.ui.toastShowHandle($popup.attr('data-locked-message') || 'Add more to unlock.');
					return;
				}
				cartFn.replaceFreeGift($btn.attr('data-variant-id'), $btn);
			});

			$(document).on('click', '.ws-cart-free-gift__product-add', function(e) {
				e.preventDefault();
				e.stopPropagation();
				var $btn = $(this);
				cartFn.syncFreeGiftCurrencyState($btn.closest('.ws-cart-free-gift'));
				if ($btn.attr('data-locked') === 'true') {
					WS.ui.toastShowHandle && WS.ui.toastShowHandle($btn.attr('data-locked-message') || 'Add more to unlock.');
					return;
				}
				var variantId = $btn.attr('data-variant-id');
				if (!variantId) {
					WS.ui.toastShowHandle && WS.ui.toastShowHandle(WS.ui.errorMsgMap.baseError);
					return;
				}
				var $popup = cartFn.findFreeGiftPopupForTrigger($btn);
				if ($popup.length) {
					$popup.attr('data-free-gift-entry', cartFn.getFreeGiftPopupEntry($btn));
				}
				cartFn.replaceFreeGift(variantId, $popup);
			});

			$(document).on('click', '[data-cart-free-gift-footer]', function(e) {
				if ($(e.target).closest('.ws-cart-free-gift__product-add').length) return;
				e.preventDefault();
				$(this).find('.ws-cart-free-gift__product-add').trigger('click');
			});

			$(document).on('keydown', '[data-cart-free-gift-footer]', function(e) {
				if (e.key !== 'Enter' && e.key !== ' ') return;
				e.preventDefault();
				$(this).trigger('click');
			});

			// 输入框输入校验
			$(document).on('input', '.enter-coupon-code-model .coupon-code-inp', function(e) {
				// 获取code
				var domInp = $('.enter-coupon-code-model .coupon-code-inp');
				var domBtn = $('.enter-coupon-code-model .exchange-coupon-code-btn');
				var codeInp = $(domInp).val();
				if (codeInp) {
					$(domBtn).addClass('exchange-btn-active');
				} else {
					$(domBtn).removeClass('exchange-btn-active');
				}
			});

			// 点击兑换code
			var firstStatus = true;
			$(document).on("click", "#exchange-coupon-code-btn", function () {
				// 获取code
				var codeInp = $('.enter-coupon-code-model .coupon-code-inp').val();
				if (!codeInp) {
					WS.ui.toastShowHandle('Please enter your coupon code');
					return;
				}
				// 判断
				if (!firstStatus) {
          			return;
				}
				firstStatus = false;
				// 加载动画
				var oldDom = $('#exchange-coupon-code-btn').html();
				WS.ui.loadingBtnShow($('#exchange-coupon-code-btn'), 2);
				// 接口
				WS.ajax({
					url: WS.ui.routes.checkAndReceiveDiscountCode,
					type: "GET",
					data: {
						discountCode: codeInp,
					},
					success: function (res) {
						if (!res.hasError && res.code == '0' && res.data) {
							// 成功
							$('.enter-coupon-code-model .coupon-code-box').removeClass('coupon-code-box-error');
							$('.enter-coupon-code-model .code-error-tip').text('');
							$('.enter-coupon-code-model .coupon-code-inp').val('');
							$('.enter-coupon-code-model .exchange-coupon-code-btn').removeClass('exchange-btn-active');
							// 隐藏动画
							WS.ui.loadingBtnHide($('#exchange-coupon-code-btn'), oldDom);
							// 把兑换的券加入优惠券数组
							WS.ui.isLogin() && userCouponList.push(res.data);
							// 处理数据
							var couponInfo = cartFn.getSingleDiscountInfo(res.data);
							// 判断领取的优惠券是否能使用
							if (couponInfo.vailable) {
								// 赋值
								confirmUseCoupon = res.data;
								userAvailableCouponList.push(res.data);
							}
							// 插入已兑换的优惠券
							var couponItemDom = WS.ui.renderCouponItem({
								couponItem: couponInfo, 
								couponIndex: 100, 
								couponType: couponInfo.vailable ? 2 : 1,
								checkedCoupon: confirmUseCoupon,
								needCopyBtn: false,
							});
							var couponDom = `<div class="get-coupon-box available-coupon-list">${couponItemDom}</div>`;
							if ( $('.enter-coupon-code-model .get-coupon-box').length ) {
								$('.enter-coupon-code-model .get-coupon-box').html(couponItemDom)
							} else {
								$('.enter-coupon-code-model').append(couponDom);
							}
							// 去选其他选中的优惠券
							if (couponInfo.vailable) {
								$('.ws-pop-coupon-edit .cart-available_coupon-box .coupon-checkbox').removeClass('icon-coupon-checked');
							} else {
								$('.enter-coupon-code-model .get-coupon-box').append(`<p class="code-error-tip" style="margin-top: 6px;padding-left: 0px;">Your current account or order status does not meet the coupon usage conditions.</p>`)
							}
							// 券倒计时处理
							setTimeout(function() {
								WS.ui.renderCountDownTimer('.ws-pop-coupon-edit-con');
							}, 300)
							// 赋值
							firstStatus = true;
						} else {
							// 失败
							$('.enter-coupon-code-model .coupon-code-box').addClass('coupon-code-box-error');
							$('.enter-coupon-code-model .code-error-tip').text(res.error.message);
							// 赋值
							firstStatus = true;
							// 隐藏动画
							WS.ui.loadingBtnHide($('#exchange-coupon-code-btn'), oldDom);
							// 判断券是否已经存在，存在就选中
							if (res.error.code === 'T10056') {
                $(`.available-coupon-list .coupon-checkbox[code=${codeInp}]`).click();
							}
						}
					},
					error: function (error) {
						// 失败
						$('.enter-coupon-code-model .coupon-code-box').addClass('coupon-code-box-error');
						$('.enter-coupon-code-model .code-error-tip').text('Something wrong, please try again later.');
						// 赋值
						firstStatus = true;
						// 隐藏动画
						WS.ui.loadingBtnHide($('#exchange-coupon-code-btn'), oldDom);
					},
				});
			})

			// 点击选中要使用的优惠券confirmUseCoupon
			$(document).on("click", ".available-coupon-list .coupon-item", function () {
				var targetIcon = $(this).find('.coupon-checkbox');
				var code = $(targetIcon).attr('code');
				if ( $(targetIcon).hasClass('icon-coupon-checked') ) {
					confirmUseCoupon = '';
					$(targetIcon).removeClass('icon-coupon-checked');
				} else {
					var checkedCoupon = userAvailableCouponList.find(item => item.discountCode == code);
					if ( checkedCoupon ) {
						confirmUseCoupon = checkedCoupon;
					}
					$('.available-coupon-list .coupon-checkbox').removeClass('icon-coupon-checked');
					$(targetIcon).addClass('icon-coupon-checked');
				}
			})

			// 点击优惠券模块
			$(document).on("click", "#cart-discount-module-text-html, #ws-shopping-cart-discount-module-text-html", function () {
				WS.stat({
					eid: WS.ui.reportType['click'],
					ext1: WS.ui.loginRegistrationProcessMap['subscriptionClick']
				});
				window.addEventListener('ws:subscribe:submit', function (evt) {
					var detail = evt && evt.detail ? evt.detail : {};
					if (!detail.isSuccess) return;
					var isSubscribed = WS.ui.subscribeModuleFn && WS.ui.subscribeModuleFn.isSubscribed === true;
					var isFirstOrder = WS.ui.subscribeModuleFn && WS.ui.subscribeModuleFn.isFirstOrder === true;
					if (isSubscribed && isFirstOrder) {
						cartFn.request(true);
						WS.ui.subscribeModuleFn.closeSubscribePopup(detail.popup);
						WS.ui.toastShowHandle('Unlocked', 2500);
						return;
					}
					if (isSubscribed && !isFirstOrder) {
						cartFn.initCartDiscountModule(true);
					}
				}, { once: true });
				WS.ui.subscribeModuleFn.openSubscriptionPopup();
			});

			// 优惠券弹窗关闭
			$(document).on("click", ".ws-main-popupbox-coupon-edit .ws-main-popupbox-overlay,.ws-main-popupbox-coupon-edit .title-close", function () {
				// 类型
				var type = $(this).attr('type');
				// 上报
				cartFn.cartReportHandle(WS.ui.reportType['click'], type === 1 ? WS.ui.reportMap['clickBlankCouponsListPop'] : WS.ui.reportMap['clickIcCloseCouponsListPop']);
			})

			$(document).on('input', '#ws-cart-discount-input', function () {
				clearCartDiscountError();
				var code = $('#ws-cart-discount-input').val();
				if (code) {
					$('#ws-cart-discount-apply').addClass('ws-cart-discount-apply--active');
				} else {
					$('#ws-cart-discount-apply').removeClass('ws-cart-discount-apply--active');
				}
			});

			$(document).on('click', '#ws-cart-discount-apply', function () {
				var code = $('#ws-cart-discount-input').val();
				if (!String(code || '').trim()) { showCartDiscountError('Please enter a discount code.'); return; }
				cartFn.applyCartDiscountCode(code);
			});
			$(document).on('keydown', '#ws-cart-discount-input', function(event) {
				if (event.key === 'Enter') { event.preventDefault(); $('#ws-cart-discount-apply').trigger('click'); }
			});

			// 折扣标签上的删除（仅购物车级折扣 tag，westyle-tag-item）
			$(document).on('click', '.ws-tag-item__remove', function (e) {
				e.preventDefault();
				e.stopPropagation();
				restoreSubtotalPopAfterNextBottomRender = $('#btn-wrapper-pop-abt').hasClass('btn-wrapper-pop-abt-active');
				var code = $(this).attr('data-ws-discount-code') || '';
				cartFn.clearCartDiscountCode(code);
			});

			// 点击底部右侧价格区域展开价格详情弹窗
			$(document).on("click", ".btn-wrapper-right", function () {
				// 判断是否打开弹窗
				if ( $('.saving-triangle').hasClass('saving-triangle-active') ) {
					cartFn.applySubtotalPopOpenState(false);
					// 上报
				  cartFn.cartReportHandle(WS.ui.reportType['click'], WS.ui.globalReportMap['clickDownArrowSubtotalPop'])
				} else {
					cartFn.applySubtotalPopOpenState(true);
					// 上报
					cartFn.cartReportHandle(WS.ui.reportType['moduleShow'], WS.ui.globalReportMap['showSubtotalPop'], {ext5: 'pul_up_arrow'})
				}
			});

			// 点击顶部营销文案弹窗，打开侧边栏购物车
			$(document).on("click", ".ws-market-checkout-tipimg-abt", function () {
				// 取消营销tip弹窗
				$('.ws-market-checkout-tipimg-abt').remove();
				// 打开侧边栏购物车
				cartFn.handleOpenDrawer('sale_pop');
				// 上报
        WS.stat({
          eid: WS.ui.reportType['click'],
          ext1: WS.ui.reportMap['clickGoCheckout']
        });
			});

			var classNameArr = [".minus-btn", ".increase-btn", ".quantity"];
			classNameArr.forEach((className) => {
				_$on(className);
			});

			function _$on(className) {
				var handle = className === ".quantity" ? "blur" : "click";
				$(document).on(handle, className, function () {
					var cartId = $(this).attr("data-id");
					var type = _getCalcMethod(className);
					cartFn.handleCalc(type, cartId, this);
				});
			}

			function _getCalcMethod(className) {
				var res = "";
				switch (className) {
					case classNameArr[0]:
						res = MINUS_TYPE;
						break;
					case classNameArr[1]:
						res = INCREASE_TYPE;
						break;
					case classNameArr[2]:
						res = CHANGE_TYPE;
						break;
				}
				return res;
			}

			// 复制优惠券code
			$(document).on("click", "#coupon-copy-btn", function () {
				// 复制方法
				var text = $(this).attr("data-clipboard-text");
				WS.ui.copyToClip(text);
				// 上报
				WS.ui.reporterMuti(
					4,
					`${WS.ui.reportMap['couponCode']}.${text}`,
					WS.ui.reportType["click"],
				);
			});

			// 点击关闭弹窗
			$(document).on(
				"click",
				".cart-header__close,.cart-drawer_container_overlay",
				function (e) {
					// 恢复弹窗底部滚动方法
					WS.ui.popupRecoveryScrollHandle();
					WS.ui.operateZeSnippet(2);
					var cartDrawer = $("#cart-drawer");
					var returnFocusEl = cartDrawerReturnFocusEl;
					cartDrawerReturnFocusEl = null;
					$(cartDrawer).removeClass("is-visible");
					setTimeout(function () {
						$(cartDrawer).removeClass("is-active");
						if (returnFocusEl && document.documentElement.contains(returnFocusEl) && !$(cartDrawer).hasClass('is-active')) {
							returnFocusEl.focus();
						}

						// 显示购物车显示客服
						if (!$('#chat-iframe-open-btn').length) {
							$('#tidio-chat-iframe').length && $('#tidio-chat-iframe').show();
						}
					}, 350);

					var isOverlay = $(this).hasClass('cart-drawer_container_overlay');
					var ext1 = isOverlay ? WS.ui.reportMap['clickCartDrawerOverlay'] : WS.ui.reportMap['closeCartDrawer'];
					WS.stat({
						eid: WS.ui.reportType['click'],
						ext1,
					});
				}
			);

			$(document).on('keydown', function (e) {
				var drawer = document.getElementById('cart-drawer');
				if (!drawer || !drawer.classList.contains('is-active')) return;
				if ($('#ws-free-gift-terms-popup.is-active, .ws-cart-free-gift-popup.is-active').length) return;
				if ($('.ws-main-popupbox-product:visible').length) return;
				if (e.key === 'Escape') {
					e.preventDefault();
					$(drawer).find('.cart-header__close').trigger('click');
					return;
				}
				if (e.key !== 'Tab') return;
				var focusable = $(drawer).find('a[href], button:not([disabled]), input:not([disabled]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])').filter(function () {
					return $(this).is(':visible') && !$(this).closest('[inert], [aria-hidden="true"]').length;
				}).toArray();
				if (!focusable.length) return;
				var first = focusable[0];
				var last = focusable[focusable.length - 1];
				if (!drawer.contains(document.activeElement)) {
					e.preventDefault();
					(e.shiftKey ? last : first).focus();
				} else if (e.shiftKey && document.activeElement === first) {
					e.preventDefault();
					last.focus();
				} else if (!e.shiftKey && document.activeElement === last) {
					e.preventDefault();
					first.focus();
				}
			});

			// 打开侧边栏购物车
			$(document).on("click", "#ws-cart-bag", function (e) {
				e.preventDefault();
				var isGiftCardProductUrl = WS.site.page === 'product' && /\/products\/gift-card(?:\/|$)/.test(window.location.pathname);
				if (WS.site.page !== 'index' && WS.site.page !== 'collection' && WS.site.page !== 'search' && (WS.site.page !== 'product' || isGiftCardProductUrl)) {
					location.href = `${WS.site.baseUrl}/cart`;
					return;
				}
				// 当页面不是购物车页时
				if ( WS.site.page != 'cart' ) {
          		// 打开侧边栏购物车
				  cartFn.handleOpenDrawer('nav_icon');
				}
			});

			// 确认
			$(document).on("click", "#submit-btn", function (e) {
				// 添加按钮load方法
        WS.ui.loadingBtnShow($('#submit-btn'), 1);
				cartFn.handleSubmit();
				// 储存的折扣使用信息
				var getCodeInfo = JSON.parse(localStorage.getItem(storeCoupon) || "null") || {};
				// WS.ui.setCheckoutSource(this);
				WS.ui.reporterMuti(1, WS.ui.reportMap['cartCheckout'], WS.ui.reportType['click'], getCodeInfo ? getCodeInfo.code : '', checkoutReportFrom);
			});

			$(document).on("click", "#cart-klarna", function (e) {
				// 添加按钮load方法
        WS.ui.loadingBtnShow($('#cart-klarna'), 1);
				cartFn.handleSubmit();
				// 储存的折扣使用信息
				var getCodeInfo = JSON.parse(localStorage.getItem(storeCoupon) || "null") || {};
				// WS.ui.setCheckoutSource(this);
				WS.ui.reporterMuti(1, WS.ui.reportMap['cartCheckout'], WS.ui.reportType['click'], getCodeInfo ? getCodeInfo.code : '', checkoutReportFrom);
			});

			// 取消
			$(document).on("click", "#del-all", function () {
				var slot = cartFn.renderSoldoutSlot();
				WS.ui.renderBottomDrawer({
					title: WS.$t('bag.sold_out_title', '', 1),
					slot,
				}, 'delAll');
			});

			$(document).on("click", "#confirm-delete-all-soldout", function () {
				var soldoutIdsObj = JSON.parse($(this).attr("data-soldout") || 'null') || {};
				cartApplyUpdatesPreservingDiscount(soldoutIdsObj, function () {
					$("#bottom-drawer").hide();
					cartFn.request();
					WS.ui.reporterMuti(2, WS.ui.reportMap['delAllSoldout'], WS.ui.reportType['click']);
				}, function () {
					WS.ui.toastShowHandle(WS.ui.errorMsgMap.baseError);
				});
			});

			$(document).on("click", "#check-submit", function () {
				cartFn.updateCart(cartObj);
				WS.stat({
					eid: WS.ui.reportType['click'],
					ext1: WS.ui.reportMap['confirmCheckoutSoldout'],
				});
			});

			$(document).on("click", ".del-btn", function () {
				var cartId = $(this).attr("data-id");
				cartFn._delItem(cartId, this);
			});

			$(document).on("click", ".cart_choose-size_arrow-btn", function () {
				if ($(this).closest('.cart-item_container-box').attr('data-free-gift-item') === 'true') return;
				var productId = $(this).attr('data-id');
				var productDataDom = $(this).find('.js-product-json_arrow-btn');

				var productInfo = WS.ui.getProductData(productId, productDataDom);
				productInfo.cartVariantList = cartFn.getCartVariantList();
				WS.ui.productPopupFn.lsCreatePopupHandle({
					data: productInfo,
					handle: 2,
					dataDom: this,
					productBasicSource: 3
				});
				WS.ui.reporterSingle(WS.ui.reportMap['changeSku'], this);
			});

			$(document).on("click", '.cart-image, .cart-info_title', function() {
				WS.ui.reporterSingle(WS.ui.reportMap['visitProductDetails'], this);
			});
		},
		getCartVariantList: function() {
			var onSellItems = $('#on-sell-items').find('.cart-item_container-box');
			var arr = [];
			for (var i = 0, len = onSellItems.length; i < len; i++) {
				var targetCartitem = $(onSellItems[i]);
				var cartVariantId = targetCartitem.attr('data-variant-id');
				var cartVariantQuantity = targetCartitem.attr('data-quantity');
				if (cartVariantId && cartVariantQuantity > 0) {
					var variantObj = {
						variantId: cartVariantId,
						quantity: cartVariantQuantity
					}
					arr.push(variantObj);
				}
			}
			return arr;
		},
		_delItem: function (cartId, self) {
			WS.ui.genDialogConfirm({
				text: WS.$t('bag.pop_title', '', 1),
				confirmBtnText: WS.$t('bag.pop_remove_btn', '', 1),
				confirmCallback: function () {
					return new Promise(function (resolve, reject) {
						// 加载loading弹窗
						WS.ui.loadingPopShow && WS.ui.loadingPopShow();
						WS.ajax({
							url: WS.ui.routes.changeCarItemtUrl,
							type: "POST",
							data: {
								id: cartId,
								quantity: 0,
							},
							success: function () {
								cartFn.request(false, 1);
								WS.ui.reporterSingle(WS.ui.reportMap['delCartItem'], self);
								resolve();
								// toast方法
								WS.ui.toastShowHandle(WS.$t('bag.remove_succ_toast', '', 1));
							},
							error: function (e) {
									WS.ui.toastShowHandle(WS.ui.errorMsgMap.baseError);
								reject();
							},
							complete: function () {
								WS.ui.loadingPopHide && WS.ui.loadingPopHide();
							}
						});
					}).finally(function () {
						WS.ui.loadingPopHide && WS.ui.loadingPopHide();
					});
				},
			});
		},
		/**
		 * 加载购物车item
		 * @param {*} data
		 * @returns
		 */
		renderCartItem: function (data) {
			var cartItem = `
			<div class="cart-item_container">
				<div class="js-product-json" style="display: none;">
					{
						"id": ${data.id},
						"url": "${data.url}", 
						"productId": ${data.productId },
						"sku": ${data.sku},
						"quantity": ${data.quantity},
						"variants": ${data.variants}
					}
				</div>
				<a href="${data.url}" class="cart-image_wrapper">
					<img
						class="cart-image"
						src="${data.url}"
						loading="lazy"
						width="108"
						height="142"
						object-fit="contain"
					/>
					${
						data.isSoldout
							? `<div class="sold-out_wrapper">
							<div class="text">${WS.$t('bag.sold_out_text')}</div>
						</div>`
							: ""
					}
				</a>

				<div class="cart-item_right">
					<div class="cart-info_wrapper">
						<div class="price-wrapper">
							<div class="price">${data.currencyCode}${data.price}</div>
						</div>
						<div class="title">${data.title}</div>
						<div class="size-info">
							<div class="size">
								${data.size}
							</div>
						</div>
						${
							!data.isSoldout && data.max_quantity
								? `<div class="cart-tip_max-quantity">Quantity changed to ${data.max_quantity}</div>`
								: ""
						}
					</div>
				</div>      
			</div>
			`;
			return cartItem;
		},
		/**
		 * 上报方法
		 */
    cartReportHandle: function(reportType, ext1, params) {
			// 获取购物车信息
			var data = {
				currency: WS.site.currency,
				total: $('#cart-total').text() || 0,
				sum: $('.mobile-header .ws-header-cart-count').text() || 0
			}
			var code = $('#ws-cart-coupon_code').text();
			// 上报
			WS.stat({
				eid: reportType,
				ext1: ext1,
				ext3: JSON.stringify(data),
				ext4: 'code=' + (code || 'NA'),
				...params
			});
		}

	};

	function init() {
		if (WS.site.page == 'cart') {
			cartFn.loadCartPage();
		} else {
			cartFn.getCartDataInfo(-1, -1);
		}
		cartFn.bindEvent();
		cartFn.syncFreeGiftCurrencyState();
		cartFn.syncPickAnyTwoGuidance();
	}

	init();

	WS.ui.cartFn = {
		getCartDataInfo: cartFn.getCartDataInfo,
		getCartCount: function () {
			return Number(originCartNumber) || 0;
		},
		getCampaignCartCount: function () {
			if (!originCartDataReady) return null;
			return Number(originCartCampaignNumber) || 0;
		},
		request: cartFn.request,
		loadCartPage: cartFn.loadCartPage,
		handleOpenDrawer: cartFn.handleOpenDrawer,
		applyCartDiscountCode: cartFn.applyCartDiscountCode,
		clearCartDiscountCode: cartFn.clearCartDiscountCode,
		// 对外调用时仍绑定内部购物车对象，确保自动折扣后的购物车快照保持同步。
		ensureAutoDiscountApplied: function (done) {
			cartFn.ensureAutoDiscountApplied(done);
		},
	};
})();
